(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95405],{

/***/ 45301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3444);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31567);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66037);
/* harmony import */ var _material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51115);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);








function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        root: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1]
        },
        button: _defineProperty({
            margin: theme.spacing(0, 0.5),
            display: 'inline-block',
            color: theme.palette.common.white
        }, theme.breakpoints.down('md'), {
            margin: theme.spacing(0.25)
        }),
        questionWrapper: {
            textAlign: 'left',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            width: '100%',
            padding: theme.spacing(2),
            marginBottom: theme.spacing(3),
            border: '1px solid transparent',
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.black,
            textTransform: 'none',
            '& .MuiButton-label>* ': {
                margin: 0
            }
        },
        questionWrapperExp: {
            boxShadow: 'none',
            marginBottom: 0,
            borderBottom: 0,
            borderRadius: "".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px 0 0"),
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            '&:hover': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main
            }
        },
        answer: {
            textAlign: 'left',
            border: "1px solid ".concat(theme.palette.primary.main),
            borderRadius: "0 0 ".concat(theme.shape.borderRadius, "px ").concat(theme.shape.borderRadius, "px"),
            marginBottom: theme.spacing(3),
            padding: theme.spacing(3),
            '& .MuiCollapse-wrapperInner>*': {
                margin: theme.spacing(0, 0, 1),
                '&:last-child': {
                    marginBottom: 0
                }
            }
        },
        dropButton: {
            padding: 5,
            height: 35,
            width: 35,
            borderRadius: '50%',
            border: "1px solid ".concat(theme.extraColors.greyLight),
            transition: 'transform .25s ease-in-out'
        },
        dropButtonDown: {
            color: theme.palette.primary.main
        },
        dropButtonUp: {
            color: theme.palette.common.white,
            transform: 'rotate(180deg)'
        }
    });
});
var FaqQuestion = function(param) {
    var question = param.question, answer = param.answer, questionId = param.questionId, handleExpandClick = param.handleExpandClick, isExpanded = param.isExpanded, cat = param.cat, close_others = param.close_others;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_6__/* .useTranslation */ .$)().t;
    var classes = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), simpleExpand = ref[0], setSimpleExpand = ref[1];
    var handleExpandClickSimple = function() {
        setSimpleExpand(!simpleExpand);
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq', classes.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                variant: "body1",
                component: "h3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    onClick: close_others ? function() {
                        return handleExpandClick(questionId, cat);
                    } : handleExpandClickSimple,
                    "aria-expanded": close_others ? isExpanded : simpleExpand,
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__question', classes.questionWrapper, !(close_others ? isExpanded : simpleExpand) ? classes.questionWrapper : classes.questionWrapperExp),
                    color: "primary",
                    size: "small",
                    disableRipple: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            data: question,
                            defaultText: t('texts:general:add_a_text')
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__btn', classes.dropButton, !(close_others ? isExpanded : simpleExpand) ? classes.dropButtonDown : classes.dropButtonUp)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                in: close_others ? isExpanded : simpleExpand,
                timeout: 0,
                mountOnEnter: true,
                unmountOnExit: true,
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)('faq__answer', classes.answer),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    data: answer,
                    defaultText: t('texts:general:add_a_text')
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqQuestion);


/***/ }),

/***/ 39998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36456);
/* harmony import */ var _redux_services_taxons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50173);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16502);








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var mapStateToProp = function(state) {
    return {
        taxons: state.taxons.items
    };
};
var HreflangLinks = function(param) {
    var locales = param.locales, taxons = param.taxons;
    var ref3;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var asPath = router.asPath, defaultLocale = router.defaultLocale, locale = router.locale;
    var category = router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.slug;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(new Map()), allTaxons = ref1[0], setAllTaxons = ref1[1];
    var uniqueLocales = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return Array.from(new Set(locales.map(function(loc) {
            return loc.split('-')[0];
        }))).map(function(uniqueLoc) {
            return locales.find(function(loc) {
                return loc.startsWith(uniqueLoc);
            });
        }).filter(function(loc) {
            return !!loc;
        });
    }, [
        locales
    ]);
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), currentOrigin = ref2[0], setCurrentOrigin = ref2[1];
    var defaultLang = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return uniqueLocales.find(function(lang) {
            return lang.includes(defaultLocale);
        });
    }, [
        defaultLocale,
        uniqueLocales
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            setCurrentOrigin(window.location.origin);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref4;
        if (!router.isReady || taxons.length === 0 || locales.length === 1 || !category) return;
        setAllTaxons(new Map([
            [
                locale,
                ((ref4 = taxons[0]) === null || ref4 === void 0 ? void 0 : ref4.children) || []
            ]
        ]));
        var fetchTaxons = function() {
            var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(localesToFetch) {
                var ref, fetchedTaxons;
                return _home_ubuntu_build_wl_front_1_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return (0,_redux_services_taxons__WEBPACK_IMPORTED_MODULE_6__/* .getLocalesTaxons */ .OD)(localesToFetch);
                        case 3:
                            fetchedTaxons = _ctx.sent;
                            setAllTaxons(new Map(_toConsumableArray(Object.entries(fetchedTaxons)).concat([
                                [
                                    locale,
                                    ((ref = taxons[0]) === null || ref === void 0 ? void 0 : ref.children) || []
                                ], 
                            ])));
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchTaxons(localesToFetch) {
                return _ref.apply(this, arguments);
            };
        }();
        fetchTaxons(uniqueLocales.map(function(loc) {
            return loc.split('-')[0];
        }).filter(function(loc) {
            return loc !== locale;
        }));
    }, [
        locale,
        locales,
        taxons,
        router.isReady,
        uniqueLocales
    ]);
    var hreflangLinks = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var links = [];
        var slugs = category ? Array.isArray(category) ? _toConsumableArray(category) : [
            category
        ] : [];
        locales.forEach(function(loc) {
            var isDefault = loc === defaultLang;
            var currentLocale = loc.split('-')[0];
            if (isDefault) {
                var href = "".concat(currentOrigin).concat(asPath);
                if (currentLocale !== locale && (slugs === null || slugs === void 0 ? void 0 : slugs.length) > 0 && allTaxons.size > 1) {
                    href = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__/* .translateUrlSlugs */ .fg)(href, _toConsumableArray(slugs), allTaxons.get(locale), allTaxons.get(currentLocale));
                }
                links.push({
                    href: href.endsWith('/') ? href.slice(0, -1) : href,
                    hreflang: 'x-default'
                });
            }
            var href1 = "".concat(currentOrigin).concat(isDefault ? '' : "/".concat(currentLocale)).concat(asPath);
            if (currentLocale !== locale && (slugs === null || slugs === void 0 ? void 0 : slugs.length) > 0 && allTaxons.size > 1) {
                href1 = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__/* .translateUrlSlugs */ .fg)(href1, _toConsumableArray(slugs), allTaxons.get(locale), allTaxons.get(currentLocale));
            }
            links.push({
                href: href1.endsWith('/') ? href1.slice(0, -1) : href1,
                hreflang: loc
            });
        });
        return links;
    }, [
        locales,
        defaultLang,
        currentOrigin,
        asPath,
        locale,
        taxons,
        allTaxons
    ]);
    if (!currentOrigin || locales.length === 0 || !defaultLang) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
        children: hreflangLinks.map(function(link, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                rel: "alternate",
                href: link.href,
                hrefLang: link.hreflang
            }, index);
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_5__/* .connect */ .$j)(mapStateToProp)(HreflangLinks));


/***/ }),

/***/ 52965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86010);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8920);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43832);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87193);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63457);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(45332);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22318);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86700);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94455);







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var moduleHeight = 218;
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        marginNull: {
            margin: 0
        },
        paddingNull: {
            padding: 0
        },
        padding: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6)
        },
        instaWall: {
            position: 'relative',
            minHeight: moduleHeight * 1.5
        },
        insta: _defineProperty({
            minHeight: moduleHeight,
            maxWidth: 407,
            minWidth: 300,
            padding: 5,
            borderRadius: theme.shape.borderRadius,
            position: 'absolute',
            backgroundColor: theme.palette.common.white,
            top: '50%',
            left: '50%',
            transform: 'translateX(-50%) translateY(-50%)'
        }, theme.breakpoints.up('lg'), {
            minWidth: 407
        }),
        instaBox: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            border: "1px solid ".concat(theme.palette.primary.main),
            minHeight: 218,
            borderRadius: theme.shape.borderRadius * 0.75,
            textAlign: 'center',
            padding: '10px'
        },
        share: _defineProperty({}, theme.breakpoints.up('md'), {
            padding: 10
        }),
        logoInsta: {
            paddingBottom: '10px',
            width: 50
        },
        gridImg: {
            objectFit: 'cover'
        }
    });
});
var InstaWall = function(param) {
    var _isSmall = param.isSmall, isSmall = _isSmall === void 0 ? false : _isSmall, data = param.data, t = param.t;
    var ref3, ref1, ref2;
    var classes = useStyles();
    var theme = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
    var images = data === null || data === void 0 ? void 0 : data.instagramimages;
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)().trackEvent;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "section-instawall ".concat(classes.instaWall),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            maxWidth: "xl",
            className: isSmall ? classes.paddingNull : classes.padding,
            children: [
                images && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    container: true,
                    justify: "center",
                    children: !isSmall ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        cellHeight: 154,
                        cols: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(theme.breakpoints.up('md')) ? 7 : 2,
                        spacing: 9,
                        children: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(theme.breakpoints.up('md')) ? images.map(function(tile, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                cols: 1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: classes.gridImg,
                                    src: tile.image.url,
                                    alt: tile.image.alt === null ? '' : tile.image.alt
                                })
                            }, index);
                        }) : images.slice(0, 4).map(function(tile, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                cols: 1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: classes.gridImg,
                                    src: tile.image.url,
                                    alt: tile.image.alt === null ? '' : tile.image.alt
                                })
                            }, index);
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        cellHeight: 154,
                        cols: 2,
                        spacing: 9,
                        children: images.slice(0, 4).map(function(tile, index) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                cols: 1,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: tile.image.url,
                                    alt: tile.image.alt === null ? '' : tile.image.alt
                                })
                            }, index);
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classes.insta,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classes.instaBox,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: (data === null || data === void 0 ? void 0 : (ref3 = data.instagramlogo) === null || ref3 === void 0 ? void 0 : ref3.url) ? data.instagramlogo.url : '/images/placeholder.jpg',
                                alt: "Instagram",
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(classes.logoInsta, 'instagram__logo')
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                variant: "h4",
                                component: "h2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: data === null || data === void 0 ? void 0 : data.title,
                                    defaultText: t('texts:instagramwall:title')
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classes.share,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    color: 'secondary',
                                    component: "div",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                        asText: true,
                                        data: data === null || data === void 0 ? void 0 : data.desc,
                                        defaultText: t('texts:instagramwall:desc')
                                    })
                                })
                            }),
                            ((ref1 = data === null || data === void 0 ? void 0 : data.buttontext[0]) === null || ref1 === void 0 ? void 0 : ref1.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                size: (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(theme.breakpoints.down('md')) ? 'small' : 'large',
                                variant: "contained",
                                className: "instaWall__instaButton",
                                onClick: function() {
                                    var ref;
                                    return trackEvent({
                                        category: 'HomePage',
                                        href: data === null || data === void 0 ? void 0 : (ref = data.link) === null || ref === void 0 ? void 0 : ref.url,
                                        action: "Universe Section leave website to instagram profile page"
                                    });
                                },
                                color: "primary",
                                href: (data === null || data === void 0 ? void 0 : (ref2 = data.link) === null || ref2 === void 0 ? void 0 : ref2.url) ? data.link.url : '/',
                                target: "blank",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    asText: true,
                                    data: data === null || data === void 0 ? void 0 : data.buttontext,
                                    defaultText: t('texts:instagramwall:buttontext')
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InstaWall);


/***/ }),

/***/ 3444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(97650);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
;// CONCATENATED MODULE: ./components/HomePage/styles/HeroHome.style.tsx

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1, _obj2;
    return (0,createStyles/* default */.Z)({
        color_white: {
            color: theme.palette.common.white
        },
        invert: {
            filter: 'invert(1)'
        },
        root: {
            zIndex: 2,
            position: 'relative',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            minHeight: '80vh',
            justifyContent: 'center',
            textAlign: 'center',
            overflow: 'hidden',
            '&.filter': {
                '&::after': {
                    zIndex: 1,
                    position: 'absolute',
                    content: "''",
                    height: '100%',
                    width: '100%',
                    top: 0,
                    bottom: 0,
                    left: 0,
                    opacity: 0.6,
                    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 72.15%, #000000 100%)'
                }
            },
            '&.center': {
                '& .layout': _defineProperty({}, theme.breakpoints.up('md'), {
                    justifyContent: 'center',
                    textAlign: 'center',
                    '& .MuiGrid-grid-md-6': {
                        maxWidth: '100%',
                        flexBasis: '100%',
                        '& +.MuiGrid-grid-md-6>div': {
                            maxWidth: 680,
                            margin: 'auto'
                        }
                    },
                    '& .tagline, & .statements > .MuiGrid-root': {
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    },
                    '& .date_form, & .ctas': {
                        justifyContent: 'center'
                    }
                })
            },
            '&.left': {
                '&.filter:after': _defineProperty({}, theme.breakpoints.up('md'), {
                    left: 0,
                    background: 'linear-gradient(90deg, #000000 0%, rgba(0, 0, 0, 0.8) 42.42%, rgba(37, 24, 56, 0) 100%)'
                }),
                '& .MuiBox-root': _defineProperty({}, theme.breakpoints.up('md'), {
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                    '& .date_form': {
                        justifyContent: 'flex-start'
                    }
                })
            },
            '&.right': {
                '&.filter:after': _defineProperty({}, theme.breakpoints.up('md'), {
                    height: '100%',
                    left: 'auto',
                    right: 0,
                    background: 'linear-gradient(-90deg, #000000 0%, rgba(0, 0, 0, 0.8) 42.42%, rgba(37, 24, 56, 0) 100%)'
                }),
                '& .layout': _defineProperty({}, theme.breakpoints.up('md'), {
                    flexDirection: 'row-reverse',
                    textAlign: 'left',
                    '& .date_form': {
                        justifyContent: 'flex-start'
                    }
                })
            }
        },
        media: {
            zIndex: -100,
            position: 'absolute',
            overflow: 'hidden',
            left: 0,
            top: theme.sizes.headerHeight,
            right: 0,
            bottom: 0,
            width: '100%',
            height: "calc(100% - ".concat(theme.sizes.headerHeight, "px)"),
            objectFit: 'cover',
            backgroundColor: theme.palette.common.black,
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%'
        },
        mediaTransparent: {
            top: 0,
            height: '100%'
        },
        wrapper: _defineProperty({
            zIndex: 3,
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: theme.sizes.headerHeight,
            minHeight: "calc(100vh - ".concat(theme.sizes.headerHeight, "px)")
        }, theme.breakpoints.up('md'), {
            minHeight: "calc(100vh - ".concat(theme.sizes.headerHeight * 2, "px)")
        }),
        wrapperTransparent: _defineProperty({
            paddingTop: theme.sizes.headerHeightTransparent,
            minHeight: "calc(100vh - ".concat(theme.sizes.headerHeightTransparent, "px)")
        }, theme.breakpoints.up('md'), {
            minHeight: "calc(100vh - ".concat(theme.sizes.headerHeightTransparent * 2, "px)")
        }),
        box: {},
        box__primary: {},
        box__secondary: _defineProperty({}, theme.breakpoints.up('md'), {
            marginTop: theme.spacing(4)
        }),
        box__ctas: (_obj1 = {}, _defineProperty(_obj1, theme.breakpoints.up('md'), {
            display: 'flex'
        }), _defineProperty(_obj1, '&>a', (_obj = {
            display: 'inline-block'
        }, _defineProperty(_obj, theme.breakpoints.down('md'), {
            margin: theme.spacing(1)
        }), _defineProperty(_obj, theme.breakpoints.up('md'), {
            margin: 0,
            '&+a': {
                margin: theme.spacing(0, 2)
            }
        }), _obj)), _obj1),
        title: _defineProperty({
            fontSize: theme.typography.pxToRem(24),
            '& .paragraph-class': {
                margin: 0
            }
        }, theme.breakpoints.up('md'), {
            fontSize: theme.typography.pxToRem(30)
        }),
        tagline: _defineProperty({
            lineHeight: 1.2,
            fontSize: theme.typography.pxToRem(12),
            marginBottom: theme.spacing(3)
        }, theme.breakpoints.up('md'), {
            fontSize: theme.typography.pxToRem(15),
            maxWidth: '75%',
            lineHeight: 'inherit'
        }),
        buttonToPack: {
            marginTop: theme.spacing(4),
            width: '100%',
            textAlign: 'center'
        },
        slide: (_obj2 = {
            padding: theme.spacing(0, 5)
        }, _defineProperty(_obj2, theme.breakpoints.down('sm'), {
            position: 'relative',
            width: '100vw',
            transform: 'translateX(-50%) translateY(0)',
            left: '50%',
            marginBottom: theme.spacing(2)
        }), _defineProperty(_obj2, '& .MuiBox-root', {
            transition: theme.transitions.create('opacity')
        }), _obj2),
        slideArrow: {
            '& .glider-next': {
                right: -40
            },
            '& .glider-prev': {
                left: -40
            }
        },
        slideActive: {
            opacity: 1,
            '& .MuiBox-root': {
                opacity: 0.75,
                '&:hover': {
                    opacity: 1
                }
            }
        },
        slideInactive: {
            opacity: 1
        },
        smallerButton: _defineProperty({}, theme.breakpoints.down('md'), {
            fontSize: theme.typography.pxToRem(12),
            padding: theme.spacing(1, 2)
        }),
        statementsMobile: {
            marginTop: theme.spacing(2)
        },
        date_form: _defineProperty({
            display: 'flex',
            textAlign: 'left',
            justifyContent: 'center',
            margin: theme.spacing(3, 0, 8)
        }, theme.breakpoints.down('sm'), {
            margin: theme.spacing(8, 0, 3),
            padding: theme.spacing(2, 1.5),
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius
        }),
        subnav: _defineProperty({
            fontSize: theme.typography.pxToRem(14),
            paddingLeft: theme.spacing(1.5),
            //color: theme.palette.common.white,
            '& a': {
                color: 'currentColor',
                fontWeigth: 700,
                textDecoration: 'underline',
                '&:hover, &:focus': {
                    textDecoration: 'none'
                }
            }
        }, theme.breakpoints.down('sm'), {
            fontSize: theme.typography.pxToRem(10)
        }),
        linkButton: _defineProperty({
            padding: 0,
            color: '#fff',
            fontSize: theme.typography.pxToRem(14),
            textDecoration: 'underline',
            margin: 0,
            '&:hover': {
                background: 'none'
            }
        }, theme.breakpoints.down('sm'), {
            fontSize: theme.typography.pxToRem(10)
        })
    });
});
/* harmony default export */ var HeroHome_style = (useStyles);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowRight.js
var KeyboardArrowRight = __webpack_require__(56251);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/esm/KeyboardArrowLeft.js
var KeyboardArrowLeft = __webpack_require__(55953);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/actions/packs.ts + 1 modules
var packs = __webpack_require__(37876);
// EXTERNAL MODULE: ./node_modules/react-glider/dist/index.js
var dist = __webpack_require__(76142);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/Statements/Statements.tsx




function Statements_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Statements_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj, _obj1;
    return (0,createStyles/* default */.Z)({
        container: Statements_defineProperty({
            maxWidth: 320,
            margin: 'auto'
        }, theme.breakpoints.up('md'), {
            margin: 0,
            maxWidth: 500,
            height: 125
        }),
        item: {
            height: '100%',
            textAlign: 'center',
            justifyContent: 'center',
            padding: theme.spacing(1),
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.common.white,
            border: '1px solid currentColor'
        },
        img: (_obj = {
            display: 'block',
            margin: 'auto',
            marginBottom: theme.spacing(1),
            height: 32
        }, Statements_defineProperty(_obj, theme.breakpoints.up('md'), {
            height: 48
        }), Statements_defineProperty(_obj, "objectFit", 'contain'), _obj),
        title: (_obj1 = {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            lineHeight: 1,
            fontWeight: 400,
            fontSize: 12,
            minHeight: 36
        }, Statements_defineProperty(_obj1, theme.breakpoints.up('md'), {
            fontSize: 14,
            minHeight: 42
        }), Statements_defineProperty(_obj1, "color", 'currentColor'), _obj1)
    });
});
var Statements = function(param) {
    var statements = param.statements, textColor = param.textColor, t = param.t;
    var ref;
    var classes = Statements_useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
        container: true,
        spacing: 1,
        className: classes.container,
        children: statements ? (ref = statements.data.statements) === null || ref === void 0 ? void 0 : ref.map(function(statement) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.item,
                    style: {
                        color: textColor
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: statement.icon.url,
                            className: classes.img,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            component: "h2",
                            className: classes.title,
                            children: (0,CMSText/* prismicText */.yz)(statement === null || statement === void 0 ? void 0 : statement.title)
                        })
                    ]
                })
            }, "state-".concat((0,CMSText/* prismicText */.yz)(statement === null || statement === void 0 ? void 0 : statement.title)));
        }) : [
            0,
            1,
            2
        ].map(function(index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                item: true,
                xs: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classes.item,
                    style: {
                        color: textColor
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: '/images/placeholder.jpg',
                            className: classes.img,
                            alt: "Here is an image"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            component: "h2",
                            className: classes.title,
                            children: t('texts:statement:title')
                        })
                    ]
                })
            }, "state-".concat(index, "-").concat(t('texts:statement.title')));
        })
    }));
};
/* harmony default export */ var Statements_Statements = (Statements);

// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./components/ImgKitHandler/ImgKitHandler.tsx
var ImgKitHandler = __webpack_require__(26137);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
;// CONCATENATED MODULE: ./components/HomePage/PackCard.tsx












function PackCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PackCard_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        packCard: PackCard_defineProperty({
            position: 'relative',
            textAlign: 'left',
            maxWidth: 190,
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            padding: theme.spacing(1),
            margin: theme.spacing(0, 'auto', 3)
        }, theme.breakpoints.up('md'), {
            maxWidth: 220
        }),
        packImage: {
            width: '100%',
            objectFit: 'contain'
        },
        alignCenter: {
            textAlign: 'center'
        },
        lineHeight: {
            lineHeight: 1.3,
            textAlign: 'center'
        },
        title: {
            marginTop: theme.spacing(1)
        },
        smallButton: {
            fontSize: theme.typography.pxToRem(12),
            padding: theme.spacing(0.5, 1),
            '& .MuiButton-endIcon': {
                marginLeft: 0
            }
        },
        price: {
            fontSize: theme.typography.pxToRem(12),
            marginBottom: theme.spacing(2)
        },
        overlayLink: {
            position: 'absolute',
            zIndex: 2,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        }
    });
});
var PackCard = function(param) {
    var isLoading = param.isLoading, isPack = param.isPack, price_pack = param.price_pack, isCustom = param.isCustom, pack = param.pack, thumbnail_ratio = param.thumbnail_ratio, text = param.text;
    var ref, ref1;
    var classes = PackCard_useStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(thumbnail_ratio);
    var largeImgWidth = text === null || text === void 0 ? void 0 : text.large_image_size;
    return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('packCard', classes.packCard),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rect",
                width: '100%',
                height: 120
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "text",
                width: 80
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "text",
                width: 100
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                variant: "rect",
                width: '100%',
                height: 32
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)('packCard', classes.packCard),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                href: !isCustom ? isPack ? '/packs' : '/shop' : pack.link.url !== undefined ? pack.link.url : '/',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: classes.overlayLink,
                    onClick: function() {
                        return trackEvent({
                            category: 'HomePage',
                            href: !isCustom ? isPack ? '/packs' : '/shop' : pack.link.url !== undefined ? pack.link.url : '/',
                            action: "CTA click ".concat(t('texts:homepage:rent')),
                            name: "from Hero Product/Pack Card to ".concat(!isCustom ? isPack ? '/packs' : '/shop' : pack.link.url !== undefined ? pack.link.url : '/')
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "srOnly",
                        children: t('texts:homepage:rent')
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                "data-ratio": aspectRatio,
                className: classes.packImage,
                children: !isCustom ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                    alt: '',
                    imagePaths: isPack && (pack === null || pack === void 0 ? void 0 : pack.images.length) > 0 ? pack.images[0] : '',
                    classes: classes.packImage,
                    settings: {
                        width: largeImgWidth,
                        ar: aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.substring(3)
                    }
                }) : (pack === null || pack === void 0 ? void 0 : (ref = pack.image) === null || ref === void 0 ? void 0 : ref.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    layout: "fill",
                    src: pack === null || pack === void 0 ? void 0 : (ref1 = pack.image) === null || ref1 === void 0 ? void 0 : ref1.url,
                    alt: '',
                    className: classes.packImage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'body1',
                className: (0,clsx_m/* default */.Z)('packCard__title', classes.title, classes.lineHeight),
                children: !isCustom ? (0,utils/* truncateString */.aS)(pack.name, 100) : (0,CMSText/* prismicText */.yz)(pack === null || pack === void 0 ? void 0 : pack.desc)
            }),
            price_pack && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'body1',
                color: 'secondary',
                className: (0,clsx_m/* default */.Z)('packCard__price', classes.price, classes.lineHeight),
                gutterBottom: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: price_pack
                })
            })
        ]
    });
};
/* harmony default export */ var HomePage_PackCard = (PackCard);

// EXTERNAL MODULE: ./components/DateRangeForm/DateRangeForm.tsx + 1 modules
var DateRangeForm = __webpack_require__(4998);
// EXTERNAL MODULE: ./redux/actions/products.ts
var products = __webpack_require__(86730);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
;// CONCATENATED MODULE: ./components/HomePage/HeroHome.tsx






















function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var HeroHomeImg = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 22781).then(__webpack_require__.bind(__webpack_require__, 22781));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22781)
            ];
        }
    }
});
var mapStateToProps = function(state) {
    return {
        packs: state.packs,
        products: state.products
    };
};
var mapDispatchToProps = {
    getPackTaxons: packs/* getPackTaxons */.Ht,
    getPacksByPackTaxonId: packs/* getPacksByPackTaxonId */.M9,
    getLatestProducts: products/* getLatestProducts */.lO
};
var HeroHome = function(param) {
    var settings = param.settings, text = param.text, products = param.products, getLatestProducts1 = param.getLatestProducts, getPackTaxons1 = param.getPackTaxons, packs = param.packs, isProduct = param.isProduct, getPacksByPackTaxonId1 = param.getPacksByPackTaxonId, statements = param.statements, children = param.children, isEnableChooseStartingDate = param.isEnableChooseStartingDate;
    var ref22, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18;
    var classes = HeroHome_style();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var theme = (0,useTheme/* default */.Z)();
    var prefersReducedMotion = (0,useMediaQuery/* default */.Z)('(prefers-reduced-motion: reduce)');
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));
    var isDesktopXL = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up('xl'));
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var isPack = (packs === null || packs === void 0 ? void 0 : (ref22 = packs.items) === null || ref22 === void 0 ? void 0 : ref22.length) > 0;
    // Matomo event tracking hook
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    // Retrieve configuration parameters with default values
    var ref19 = settings || {}, heroTextColor = ref19.hero_text_color, ctaPackLabel = ref19.cta_pack_label, packPrice = ref19.pack_price, showStatements = ref19.show_statements, showPacks = ref19.show_featured_packs, tmp = ref19.products, customProducts = tmp === void 0 ? [] : tmp, mainImg = ref19.mainimg, isVideoMobile = ref19.enable_background_video_mobile, backgroundVideoFile = ref19.background_video_file, backgroundVideoMobile = ref19.background_video_mobile, ctas = ref19.hero_ctas, headerStyle = ref19.header_style, isUseCarousel = ref19.use_carousel;
    var isCustomProducts = (customProducts === null || customProducts === void 0 ? void 0 : customProducts.length) > 0;
    var textColor = heroTextColor ? heroTextColor : '#ffffff';
    var button_to_packs = (0,CMSText/* prismicText */.yz)(ctaPackLabel);
    var price_pack = (0,CMSText/* prismicText */.yz)(packPrice);
    var video = backgroundVideoFile === null || backgroundVideoFile === void 0 ? void 0 : backgroundVideoFile.url;
    var videoMobile = backgroundVideoMobile === null || backgroundVideoMobile === void 0 ? void 0 : backgroundVideoMobile.url;
    var thumbnail_ratio = text === null || text === void 0 ? void 0 : text.thumbnail_ratio;
    var isTransparentMedia = headerStyle ? "hero__home-media--transparent ".concat(classes.media, " ").concat(classes.mediaTransparent) : "hero__home-media ".concat(classes.media);
    var ref20 = (0,react.useState)(false), activePacks = ref20[0], setActivePacks = ref20[1];
    var handleActivePack = function() {
        setActivePacks(true);
    };
    var handleDesActivePack = function() {
        setActivePacks(false);
    };
    (0,react.useEffect)(function() {
        function getTaxons() {
            return _getTaxons.apply(this, arguments);
        }
        function _getTaxons() {
            _getTaxons = _asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, taxon, ref21;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            _ctx.next = 3;
                            return getPackTaxons1();
                        case 3:
                            taxon = _ctx.sent;
                            if (typeof taxon !== 'undefined' && (taxon === null || taxon === void 0 ? void 0 : (ref = taxon.taxonPack) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                                ;
                                getPacksByPackTaxonId1((ref21 = taxon === null || taxon === void 0 ? void 0 : taxon.taxonPack[0]) === null || ref21 === void 0 ? void 0 : ref21.id);
                            }
                        case 5:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getTaxons.apply(this, arguments);
        }
        if (isProduct) {
            getLatestProducts1();
        } else {
            getTaxons();
        }
    }, []);
    var layoutOpt = (settings === null || settings === void 0 ? void 0 : (ref1 = settings.hero_layout) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) || 'left';
    var videoTag = function(src) {
        var ref;
        var posterUrl = (mainImg === null || mainImg === void 0 ? void 0 : (ref = mainImg.md) === null || ref === void 0 ? void 0 : ref.url) || '/images/video_placeholder.jpg';
        if (!prefersReducedMotion) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                className: isTransparentMedia,
                preload: "none",
                poster: posterUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: src,
                    type: "video/mp4"
                })
            }));
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HeroHomeImg, {
            src: mainImg,
            classes: isTransparentMedia,
            isMobile: isMobile,
            isDesktopXL: isDesktopXL
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hero__home ".concat(classes.root, " ").concat((settings === null || settings === void 0 ? void 0 : settings.background_filter) ? 'filter' : 'no-filter', " ").concat(layoutOpt),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            isVideoMobile && isMobile && videoTag(videoMobile),
                            isVideoMobile && !isMobile && videoTag(video),
                            !isVideoMobile && video && videoTag(video),
                            !isVideoMobile && !video && /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroHomeImg, {
                                src: mainImg,
                                classes: isTransparentMedia,
                                isMobile: isMobile,
                                isDesktopXL: isDesktopXL
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                        maxWidth: "xl",
                        children: [
                            children,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                id: "hero__home__wrapper",
                                className: (settings === null || settings === void 0 ? void 0 : settings.header_style) ? "wrapper ".concat(classes.wrapper, " ").concat(classes.wrapperTransparent) : "wrapper ".concat(classes.wrapper),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    container: true,
                                    spacing: 3,
                                    className: "layout",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                            item: true,
                                            md: 6,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (0,clsx_m/* default */.Z)(classes.box, 'hero__home-box'),
                                                style: {
                                                    color: textColor
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: classes.box__primary,
                                                        id: "hero__box",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "h1",
                                                                className: "title ".concat(classes.title),
                                                                style: {
                                                                    color: textColor
                                                                },
                                                                component: "div",
                                                                gutterBottom: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    data: settings === null || settings === void 0 ? void 0 : settings.maintitle,
                                                                    defaultText: t('texts:homepage:maintitle')
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "body1",
                                                                className: "tagline ".concat(classes.tagline),
                                                                component: "div",
                                                                style: {
                                                                    color: textColor
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    data: settings === null || settings === void 0 ? void 0 : settings.descriptiontext,
                                                                    defaultText: t('texts:homepage:descriptiontext')
                                                                })
                                                            }),
                                                            (!isSubscription || isEnableChooseStartingDate) && constants/* isSecondHandOnly */.G7 !== 'true' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "date_form ".concat(classes.date_form),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DateRangeForm/* default */.Z, {
                                                                    isLanding: true,
                                                                    t: t,
                                                                    text: text
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    ctas && ctas.length > 0 && ((ref2 = ctas[0]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.cta_link) === null || ref3 === void 0 ? void 0 : ref3.url) !== undefined && ((ref4 = ctas[0]) === null || ref4 === void 0 ? void 0 : ref4.cta_label.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ctas ".concat(classes.box__ctas),
                                                        children: ctas.map(function(cta, index) {
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                                href: cta.cta_link.url ? cta.cta_link.url : '/',
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        variant: cta.cta_style ? 'outlined' : 'contained',
                                                                        color: cta.cta_color ? 'secondary' : 'primary',
                                                                        component: "span",
                                                                        onClick: function() {
                                                                            var ref, ref23;
                                                                            return trackEvent({
                                                                                category: "HomePage",
                                                                                href: cta === null || cta === void 0 ? void 0 : (ref = cta.cta_link) === null || ref === void 0 ? void 0 : ref.url,
                                                                                action: "CTA n\xb0".concat(index, " to page ").concat(cta === null || cta === void 0 ? void 0 : (ref23 = cta.cta_link) === null || ref23 === void 0 ? void 0 : ref23.url)
                                                                            });
                                                                        },
                                                                        children: (0,CMSText/* prismicText */.yz)(cta === null || cta === void 0 ? void 0 : cta.cta_label)
                                                                    })
                                                                })
                                                            }, index);
                                                        })
                                                    }),
                                                    showStatements && (isSubscription ? !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "statements ".concat(classes.box__secondary),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Statements_Statements, {
                                                            statements: statements,
                                                            textColor: textColor,
                                                            t: t
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "statements ".concat(classes.box__secondary),
                                                        style: {
                                                            color: textColor
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Statements_Statements, {
                                                                statements: statements,
                                                                textColor: textColor,
                                                                t: t
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                className: classes.subnav,
                                                                children: [
                                                                    (0,CMSText/* prismicText */.yz)(statements === null || statements === void 0 ? void 0 : (ref5 = statements.data) === null || ref5 === void 0 ? void 0 : ref5.bottom_sentence, t('texts:homepage:bottom_sentence')),
                                                                    ' ',
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                        className: classes.linkButton,
                                                                        variant: 'text',
                                                                        onClick: function() {
                                                                            return (0,utils/* scrollToDiv */.cx)('more');
                                                                        },
                                                                        style: {
                                                                            color: textColor
                                                                        },
                                                                        children: (0,CMSText/* prismicText */.yz)(statements === null || statements === void 0 ? void 0 : (ref6 = statements.data) === null || ref6 === void 0 ? void 0 : ref6.link, t('texts:homepage:link'))
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }))
                                                ]
                                            })
                                        }),
                                        showPacks && !isCustomProducts && (packs.loading === true && typeof (packs === null || packs === void 0 ? void 0 : packs.items) === 'undefined' || products.loading === true && typeof (products === null || products === void 0 ? void 0 : products.latestProducts) === 'undefined' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                item: true,
                                                md: 6,
                                                xs: 12,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (0,clsx_m/* default */.Z)(classes.slide, activePacks ? classes.slideActive : classes.slideInactive),
                                                        onMouseOver: handleActivePack,
                                                        onMouseOut: handleDesActivePack,
                                                        children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            container: true,
                                                            spacing: 3,
                                                            children: [
                                                                0,
                                                                1,
                                                                2
                                                            ].map(function(item) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    item: true,
                                                                    xs: 4,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                        isLoading: true
                                                                    })
                                                                }, item));
                                                            })
                                                        }) : isSubscription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            container: true,
                                                            spacing: 3,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                item: true,
                                                                xs: 12,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                    isLoading: true
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    isSubscription && !isProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classes.buttonToPack,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                            href: '/packs',
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    variant: 'contained',
                                                                    color: 'secondary',
                                                                    size: 'medium',
                                                                    component: "span",
                                                                    endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                    onClick: function() {
                                                                        return trackEvent({
                                                                            category: "HomePage",
                                                                            href: '/packs',
                                                                            action: "CTA Hero to /packs"
                                                                        });
                                                                    },
                                                                    children: button_to_packs ? button_to_packs : ''
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                            item: true,
                                            md: 6,
                                            xs: 12,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx_m/* default */.Z)(classes.slide, activePacks ? classes.slideActive : classes.slideInactive),
                                                    onMouseOver: handleActivePack,
                                                    onMouseOut: handleDesActivePack,
                                                    children: !isSubscription ? !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        container: true,
                                                        spacing: 3,
                                                        children: isPack && !isProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: packs === null || packs === void 0 ? void 0 : (ref7 = packs.items) === null || ref7 === void 0 ? void 0 : ref7.map(function(pack, index) {
                                                                if (index <= 2) {
                                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                        md: 4,
                                                                        item: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                            pack: pack,
                                                                            thumbnail_ratio: thumbnail_ratio,
                                                                            price_pack: price_pack,
                                                                            isPack: true
                                                                        })
                                                                    }, index));
                                                                }
                                                            })
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: (products === null || products === void 0 ? void 0 : (ref8 = products.latestProducts) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && (products === null || products === void 0 ? void 0 : (ref9 = products.latestProducts) === null || ref9 === void 0 ? void 0 : ref9.map(function(pack, index) {
                                                                if (index <= 2) {
                                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                        md: 4,
                                                                        item: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                            thumbnail_ratio: thumbnail_ratio,
                                                                            price_pack: price_pack,
                                                                            pack: pack
                                                                        })
                                                                    }, index));
                                                                }
                                                            }))
                                                        })
                                                    }) : isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                        draggable: true,
                                                        scrollLock: true,
                                                        slidesToShow: 1,
                                                        hasDots: true,
                                                        scrollLockDelay: 100,
                                                        duration: 1,
                                                        children: isPack ? packs === null || packs === void 0 ? void 0 : (ref10 = packs.items) === null || ref10 === void 0 ? void 0 : ref10.map(function(pack, index) {
                                                            if (index <= 2) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                    thumbnail_ratio: thumbnail_ratio,
                                                                    pack: pack,
                                                                    price_pack: price_pack,
                                                                    isPack: true
                                                                }, index));
                                                            }
                                                        }) : (products === null || products === void 0 ? void 0 : (ref11 = products.latestProducts) === null || ref11 === void 0 ? void 0 : ref11.length) > 0 && (products === null || products === void 0 ? void 0 : (ref12 = products.latestProducts) === null || ref12 === void 0 ? void 0 : ref12.map(function(pack, index) {
                                                            if (index <= 2) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                    pack: pack,
                                                                    thumbnail_ratio: thumbnail_ratio,
                                                                    price_pack: price_pack
                                                                }, index));
                                                            }
                                                        }))
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        container: true,
                                                        spacing: 3,
                                                        children: isPack && !isProduct ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                packs === null || packs === void 0 ? void 0 : (ref13 = packs.items) === null || ref13 === void 0 ? void 0 : ref13.map(function(pack, index) {
                                                                    if (index <= 2) {
                                                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                            md: 4,
                                                                            item: true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                                pack: pack,
                                                                                isPack: true
                                                                            })
                                                                        }, index));
                                                                    }
                                                                }),
                                                                ' '
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: (products === null || products === void 0 ? void 0 : (ref14 = products.latestProducts) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 && (products === null || products === void 0 ? void 0 : (ref15 = products.latestProducts) === null || ref15 === void 0 ? void 0 : ref15.map(function(pack, index) {
                                                                if (index <= 2) {
                                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                        md: 4,
                                                                        item: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                            pack: pack,
                                                                            thumbnail_ratio: thumbnail_ratio
                                                                        })
                                                                    }, index));
                                                                }
                                                            }))
                                                        })
                                                    })
                                                }),
                                                isSubscription ? isPack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.buttonToPack,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: '/packs',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: 'contained',
                                                                color: 'secondary',
                                                                className: classes.smallerButton,
                                                                component: "span",
                                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                onClick: function() {
                                                                    return trackEvent({
                                                                        category: 'HomePage',
                                                                        href: '/packs',
                                                                        action: 'HeroHome to pack'
                                                                    });
                                                                },
                                                                children: button_to_packs ? button_to_packs : ''
                                                            })
                                                        })
                                                    })
                                                }) : !isMobile && isPack && !isProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.buttonToPack,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: '/packs',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: 'contained',
                                                                onClick: function() {
                                                                    return trackEvent({
                                                                        category: 'HomePage',
                                                                        href: '/packs',
                                                                        action: 'HeroHome to pack'
                                                                    });
                                                                },
                                                                color: 'secondary',
                                                                className: classes.smallerButton,
                                                                component: "span",
                                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                children: button_to_packs ? button_to_packs : ''
                                                            })
                                                        })
                                                    })
                                                }),
                                                !isMobile && isProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes.buttonToPack,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                        href: '/shop',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                variant: 'contained',
                                                                color: 'secondary',
                                                                onClick: function() {
                                                                    return trackEvent({
                                                                        category: 'HomePage',
                                                                        href: '/shop',
                                                                        action: 'HeroHome to shop'
                                                                    });
                                                                },
                                                                className: classes.smallerButton,
                                                                component: "span",
                                                                endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                                children: 'Voir tous les produits'
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })),
                                        isCustomProducts && customProducts[0].desc.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                item: true,
                                                md: 6,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (0,clsx_m/* default */.Z)(classes.slide, activePacks ? classes.slideActive : classes.slideInactive),
                                                    onMouseOver: handleActivePack,
                                                    onMouseOut: handleDesActivePack,
                                                    children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                            draggable: true,
                                                            scrollLock: true,
                                                            slidesToShow: 1,
                                                            hasDots: true,
                                                            scrollLockDelay: 100,
                                                            duration: 1,
                                                            children: settings === null || settings === void 0 ? void 0 : (ref16 = settings.products) === null || ref16 === void 0 ? void 0 : ref16.map(function(pack, index) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                    thumbnail_ratio: thumbnail_ratio,
                                                                    price_pack: price_pack,
                                                                    pack: pack,
                                                                    isCustom: true,
                                                                    isPack: false
                                                                }, index));
                                                            })
                                                        })
                                                    }) : isUseCarousel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        container: true,
                                                        spacing: 3,
                                                        className: classes.slideArrow,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                            hasArrows: true,
                                                            draggable: true,
                                                            scrollLock: true,
                                                            slidesToShow: 3,
                                                            iconLeft: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {}),
                                                            iconRight: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {}),
                                                            scrollLockDelay: 100,
                                                            duration: 1,
                                                            children: settings === null || settings === void 0 ? void 0 : (ref17 = settings.products) === null || ref17 === void 0 ? void 0 : ref17.map(function(pack, index) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                                    md: 4,
                                                                    item: true,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: activePacks
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                            p: 1.5,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                                price_pack: price_pack,
                                                                                pack: pack,
                                                                                isCustom: true,
                                                                                isPack: false,
                                                                                thumbnail_ratio: thumbnail_ratio
                                                                            })
                                                                        }, index)
                                                                    ]
                                                                }, index));
                                                            })
                                                        })
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        container: true,
                                                        spacing: 3,
                                                        children: settings === null || settings === void 0 ? void 0 : (ref18 = settings.products) === null || ref18 === void 0 ? void 0 : ref18.map(function(pack, index) {
                                                            if (index <= 2) {
                                                                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                    md: 4,
                                                                    item: true,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PackCard, {
                                                                        thumbnail_ratio: thumbnail_ratio,
                                                                        text: text,
                                                                        price_pack: price_pack,
                                                                        pack: pack,
                                                                        isCustom: true,
                                                                        isPack: false
                                                                    })
                                                                }, index));
                                                            }
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            isSubscription && showStatements && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "statements ".concat(textColor === '#ffffff' ? classes.invert : '', " ").concat(classes.statementsMobile, " ").concat(classes.box__secondary),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Statements_Statements, {
                    statements: statements,
                    t: t,
                    textColor: textColor
                })
            })
        ]
    }));
};
/* harmony default export */ var HomePage_HeroHome = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(HeroHome));

// EXTERNAL MODULE: ./components/Layout/Header.tsx + 7 modules
var Header = __webpack_require__(91796);
// EXTERNAL MODULE: ./redux/actions/taxons.ts
var taxons = __webpack_require__(44279);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(84081);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(24002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(30172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(95186);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(52997);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/a11y/a11y.js
var a11y = __webpack_require__(10787);
;// CONCATENATED MODULE: ./components/HomePage/DiscoverCard.tsx







function DiscoverCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var DiscoverCard_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        img: {
            display: 'block',
            '&[src=""]': {
                content: "url('./no_image.jpg')"
            }
        },
        cardLink: {
            display: 'block'
        },
        card: {
            position: 'relative',
            '& .MuiTypography-root': {
                zIndex: 2,
                position: 'absolute',
                bottom: theme.spacing(1),
                left: theme.spacing(1),
                fontSize: theme.typography.pxToRem(14),
                padding: theme.spacing(1, 2),
                background: 'rgba(255, 255, 255, .75)'
            }
        },
        shadow: {
            background: theme.palette.common.white,
            boxShadow: theme.shadows[2],
            transition: theme.transitions.create('box-shadow'),
            cursor: 'pointer',
            '&:hover': {
                boxShadow: theme.shadows[10]
            }
        },
        taxonTitle: {
            padding: theme.spacing(2, 0),
            textAlign: 'center'
        },
        mainTitle: {
            width: '100%',
            textAlign: 'center',
            padding: theme.spacing(4, 0)
        },
        subtitle: {
            padding: theme.spacing(2, 0)
        },
        md5: DiscoverCard_defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        }),
        cardProduct: {
            position: 'relative'
        },
        cardProductContent: {
            zIndex: 2,
            position: 'absolute',
            bottom: theme.spacing(1),
            left: theme.spacing(1),
            padding: theme.spacing(1, 2),
            background: 'rgba(255, 255, 255, .75)'
        },
        shadowProductContent: {
            textAlign: 'center',
            padding: theme.spacing(1, 2, 0.5)
        }
    });
});
var DiscoverCard = function(param) {
    var url = param.url, name = param.name, img = param.img, productPrice = param.productPrice, taxonCat = param.taxonCat, isCarousel = param.isCarousel, isProduct = param.isProduct, ratio = param.ratio, thumbWidth = param.thumbWidth;
    var classes = DiscoverCard_useStyles();
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    return !isProduct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: {
            pathname: url === '/shop' ? "".concat(taxonCat) : "/packs",
            query: url !== '/shop' && {
                cat: taxonCat
            }
        },
        scroll: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "discover ".concat(classes.cardLink),
            onClick: function() {
                return trackEvent({
                    category: 'HomePage',
                    href: "/".concat(taxonCat),
                    action: "Universe Section to ".concat(taxonCat)
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: isCarousel ? "discover__card ".concat(classes.card) : "discover__shadow ".concat(classes.shadow),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'h3',
                        color: 'primary',
                        className: "discover__title ".concat(classes.taxonTitle),
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-ratio": ratio,
                        className: 'discover__media',
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgKitHandler/* default */.Z, {
                            classes: classes.img,
                            imagePaths: img,
                            alt: "",
                            settings: {
                                quality: 75,
                                width: thumbWidth,
                                ar: ratio === null || ratio === void 0 ? void 0 : ratio.substring(3)
                            }
                        })
                    })
                ]
            })
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: url,
        scroll: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: "discover ".concat(classes.cardLink),
            onClick: function() {
                return trackEvent({
                    category: 'Select Product',
                    action: "Select ".concat(name),
                    name: "/"
                });
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: isCarousel ? "discover__card ".concat(classes.cardProduct) : "discover__shadow ".concat(classes.shadow),
                children: [
                    name && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: isCarousel ? "discover-product__content ".concat(classes.cardProductContent) : "discover-product__content ".concat(classes.shadowProductContent),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'h5',
                                component: 'h2',
                                color: 'primary',
                                className: "discover-product__title",
                                children: name
                            }),
                            productPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'caption',
                                color: 'primary',
                                className: "discover-product__price",
                                children: productPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        "data-ratio": ratio,
                        className: 'discover__media',
                        children: img && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: img,
                            alt: '',
                            className: classes.img,
                            layout: "fill"
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/HomePage/UniversSection.tsx

















function UniversSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            UniversSection_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
core_class/* default.use */.Z.use([
    navigation/* default */.Z,
    pagination/* default */.Z,
    a11y/* default */.Z
]);
var UniversSection_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        root: (_obj = {
            textAlign: 'left',
            padding: theme.spacing(6, 0)
        }, UniversSection_defineProperty(_obj, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0)
        }), UniversSection_defineProperty(_obj, '& .swiper-slide', {
            marginBottom: theme.spacing(4)
        }), _obj),
        container: {
            display: 'flex',
            flexDirection: 'column'
        },
        title: {
            margin: theme.spacing(2)
        },
        cardLink: {
            display: 'block'
        },
        taxonTitle: {
            padding: theme.spacing(2, 0),
            textAlign: 'center'
        },
        mainTitle: {
            width: '100%',
            textAlign: 'center',
            padding: theme.spacing(4, 0)
        },
        subtitle: {
            padding: theme.spacing(2, 0)
        },
        background: {
        },
        fullwidth: {
            position: 'relative',
            width: '100vw',
            transform: 'translateX(-50%) translateY(0)',
            left: '50%'
        },
        col: {},
        md5: UniversSection_defineProperty({}, theme.breakpoints.up('lg'), {
            maxWidth: '20%',
            flexBasis: '20%'
        }),
        swiperArrows: UniversSection_defineProperty({
            position: 'relative'
        }, theme.breakpoints.up('lg'), {
            padding: theme.spacing(0, 6)
        }),
        swiperNoArrows: {},
        swiperArrow: {
            zIndex: 2,
            padding: 0,
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            minWidth: 32,
            width: 32,
            height: 32,
            background: theme.palette.common.white,
            '&[disabled]': {
                opacity: 0.3,
                cursor: 'default'
            },
            '&#swiper-taxon__prev, &#swiper-taxonPack__prev, &#swiper-products__prev': {
                left: theme.spacing(1)
            },
            '&#swiper-taxon__next, &#swiper-taxonPack__next, &#swiper-products__next': {
                right: theme.spacing(1)
            }
        },
        skeletonImg: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            borderRadius: theme.shape.borderRadius
        },
        footer: {
            textAlign: 'center'
        }
    });
});
var UniversSection_mapStateToProps = function(state) {
    return {
        taxons: state.taxons,
        taxonPack: state.taxonPack
    };
};
var UniversSection_mapDispatchToProps = {
    getTaxons: taxons/* getTaxons */.xI,
    getPackTaxons: packs/* getPackTaxons */.Ht
};
var Discover = function(param1) {
    var homePage = param1.homePage, settings = param1.settings, getTaxons1 = param1.getTaxons, getPackTaxons1 = param1.getPackTaxons, isPack = param1.isPack, taxonLimit = param1.taxonLimit, taxonPack = param1.taxonPack, taxons = param1.taxons;
    var ref42, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41;
    var classes = UniversSection_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));
    var isMobileColumn = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('xs'));
    var aspectRatio = (0,utils/* thumbnailRatio */.pm)(settings === null || settings === void 0 ? void 0 : settings.thumbnail_ratio);
    var thumbWidth = settings === null || settings === void 0 ? void 0 : settings.medium_image_size;
    var gridItemWidth = (0,utils/* columnLayout */.Zd)(homePage === null || homePage === void 0 ? void 0 : (ref42 = homePage.data) === null || ref42 === void 0 ? void 0 : ref42.classic_grid_columns);
    var gridSpacing = (0,utils/* columnSpacing */.nq)(homePage === null || homePage === void 0 ? void 0 : (ref1 = homePage.data) === null || ref1 === void 0 ? void 0 : ref1.carousel_cards_spacing);
    var isArrows = homePage === null || homePage === void 0 ? void 0 : (ref2 = homePage.data) === null || ref2 === void 0 ? void 0 : ref2.univers_carousel_arrows;
    var isFiveColumns = gridItemWidth === '20%';
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var isTaxonsChildren = (taxons === null || taxons === void 0 ? void 0 : (ref3 = taxons.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.children) === null || ref5 === void 0 ? void 0 : ref5.length) > 0;
    var swiperParamsMobile = {
        centeredSlides: true,
        spaceBetween: 0,
        loop: true,
        slidesPerView: 1.25
    };
    var swiperParamsDesktop = {
        spaceBetween: theme.spacing(gridSpacing),
        centeredSlides: false,
        loop: false
    };
    var swiperParamsTaxonsM = _objectSpread({}, swiperParamsMobile, {
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: isTaxonsChildren && taxons.items[0].children.length < 4 ? taxons.items[0].children.length : 4
            },
            1680: {
                slidesPerView: isTaxonsChildren && taxons.items[0].children.length < 6 ? taxons.items[0].children.length : 6
            }
        },
        navigation: {
            nextEl: '#swiper-taxon__next',
            prevEl: '#swiper-taxon__prev'
        }
    });
    var swiperParamsTaxonsD = _objectSpread({}, swiperParamsDesktop, {
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: isTaxonsChildren && taxons.items[0].children.length < 4 ? taxons.items[0].children.length : 4
            },
            1680: {
                slidesPerView: isTaxonsChildren && taxons.items[0].children.length < 6 ? taxons.items[0].children.length : 6
            }
        },
        navigation: {
            nextEl: '#swiper-taxon__next',
            prevEl: '#swiper-taxon__prev'
        }
    });
    var swiperParamsTaxonsPacksM = _objectSpread({}, swiperParamsMobile, {
        navigation: {
            nextEl: '#swiper-taxonPack__next',
            prevEl: '#swiper-taxonPack__prev'
        }
    });
    var swiperParamsTaxonsPacksD = _objectSpread({}, swiperParamsDesktop, {
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: isTaxonsChildren && taxons.items[0].children.length < 4 ? taxons.items[0].children.length : 4
            },
            1680: {
                slidesPerView: isTaxonsChildren && taxons.items[0].children.length < 6 ? taxons.items[0].children.length : 6
            }
        },
        navigation: {
            nextEl: '#swiper-taxonPack__next',
            prevEl: '#swiper-taxonPack__prev'
        }
    });
    var swiperParamsProductsM = _objectSpread({}, swiperParamsMobile, {
        navigation: {
            nextEl: '#swiper-products__next',
            prevEl: '#swiper-products__prev'
        }
    });
    var swiperParamsProductsD = _objectSpread({}, swiperParamsDesktop, {
        breakpoints: {
            768: {
                slidesPerView: 2
            },
            1024: {
                slidesPerView: (homePage === null || homePage === void 0 ? void 0 : (ref6 = homePage.data) === null || ref6 === void 0 ? void 0 : ref6.carousel_products) && (homePage === null || homePage === void 0 ? void 0 : (ref7 = homePage.data) === null || ref7 === void 0 ? void 0 : ref7.carousel_products.length) < 4 ? homePage === null || homePage === void 0 ? void 0 : (ref8 = homePage.data) === null || ref8 === void 0 ? void 0 : ref8.carousel_products.length : 4
            },
            1680: {
                slidesPerView: (homePage === null || homePage === void 0 ? void 0 : (ref9 = homePage.data) === null || ref9 === void 0 ? void 0 : ref9.carousel_products) && (homePage === null || homePage === void 0 ? void 0 : (ref10 = homePage.data) === null || ref10 === void 0 ? void 0 : ref10.carousel_products.length) < 6 ? homePage === null || homePage === void 0 ? void 0 : (ref11 = homePage.data) === null || ref11 === void 0 ? void 0 : ref11.carousel_products.length : 6
            }
        },
        navigation: {
            nextEl: '#swiper-products__next',
            prevEl: '#swiper-products__prev'
        }
    });
    (0,react.useEffect)(function() {
        getTaxons1();
        getPackTaxons1();
    }, []);
    var SwiperTaxons = function(param) {
        var params = param.params;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper/* Swiper */.t, _objectSpread({}, params, {
            children: isTaxonsChildren && taxons.items[0].children.map(function(taxon, index) {
                if (index < (0,CMSText/* prismicText */.yz)(taxonLimit)) {
                    var ref;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverCard, {
                            isCarousel: true,
                            url: '/shop',
                            name: taxon.name,
                            taxonCat: taxon.slug,
                            img: (taxon === null || taxon === void 0 ? void 0 : taxon.images) && (taxon === null || taxon === void 0 ? void 0 : (ref = taxon.images) === null || ref === void 0 ? void 0 : ref.length) > 0 ? taxon === null || taxon === void 0 ? void 0 : taxon.images[0] : '',
                            ratio: aspectRatio,
                            thumbWidth: thumbWidth
                        })
                    }, index));
                }
            })
        }));
    };
    var SwiperProducts = function(param) {
        var params = param.params;
        var ref45;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper/* Swiper */.t, _objectSpread({}, params, {
            children: (ref45 = homePage.data) === null || ref45 === void 0 ? void 0 : ref45.carousel_products.map(function(carousel_product, index) {
                var ref, ref43, ref44;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverCard, {
                        name: (0,CMSText/* prismicText */.yz)(carousel_product === null || carousel_product === void 0 ? void 0 : carousel_product.title),
                        productPrice: (0,CMSText/* prismicText */.yz)(carousel_product === null || carousel_product === void 0 ? void 0 : carousel_product.price),
                        url: (carousel_product === null || carousel_product === void 0 ? void 0 : (ref = carousel_product.link) === null || ref === void 0 ? void 0 : ref.url) ? carousel_product === null || carousel_product === void 0 ? void 0 : (ref43 = carousel_product.link) === null || ref43 === void 0 ? void 0 : ref43.url : '/',
                        img: carousel_product === null || carousel_product === void 0 ? void 0 : (ref44 = carousel_product.image) === null || ref44 === void 0 ? void 0 : ref44.url,
                        isProduct: true,
                        isCarousel: true,
                        ratio: aspectRatio
                    })
                }, index));
            })
        }));
    };
    var SwiperTaxonPacks = function(param) {
        var params = param.params;
        var ref46;
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper/* Swiper */.t, _objectSpread({}, params, {
            children: typeof taxonPack.items !== 'undefined' && taxonPack.items.length > 0 && ((ref46 = taxonPack.items) === null || ref46 === void 0 ? void 0 : ref46.map(function(taxon) {
                var ref;
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverCard, {
                        isCarousel: true,
                        url: '/packs',
                        name: taxon.name,
                        taxonCat: taxon.code,
                        img: (taxon === null || taxon === void 0 ? void 0 : taxon.images) && (taxon === null || taxon === void 0 ? void 0 : (ref = taxon.images) === null || ref === void 0 ? void 0 : ref.length) > 0 ? taxon === null || taxon === void 0 ? void 0 : taxon.images[0] : '',
                        ratio: aspectRatio
                    })
                }, taxon.code));
            }))
        }));
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.background,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "section-discover section__spacer ".concat(classes.root),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: 'xl',
                className: classes.container,
                children: [
                    (homePage === null || homePage === void 0 ? void 0 : (ref12 = homePage.data) === null || ref12 === void 0 ? void 0 : ref12.enable_taxon_product) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            order: (homePage === null || homePage === void 0 ? void 0 : (ref13 = homePage.data) === null || ref13 === void 0 ? void 0 : ref13.position_product_category) || 1
                        },
                        children: [
                            (0,CMSText/* isPrismicText */.LT)(homePage === null || homePage === void 0 ? void 0 : (ref14 = homePage.data) === null || ref14 === void 0 ? void 0 : ref14.title_universe) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "section-discover__head ".concat(classes.mainTitle),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'h2',
                                    component: 'h2',
                                    color: 'primary',
                                    className: "section-discover__title ".concat(classes.title),
                                    children: (0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref15 = homePage.data) === null || ref15 === void 0 ? void 0 : ref15.title_universe)
                                })
                            }),
                            (homePage === null || homePage === void 0 ? void 0 : (ref16 = homePage.data) === null || ref16 === void 0 ? void 0 : ref16.subtitle_universe1.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)('section-discover__subtext', 'section-discover__subtext--categories', classes.subtitle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h2',
                                        color: 'textPrimary',
                                        className: "section-discover__subtitle ".concat(classes.title),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            data: homePage === null || homePage === void 0 ? void 0 : (ref17 = homePage.data) === null || ref17 === void 0 ? void 0 : ref17.subtitle_universe1,
                                            asText: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: 'body1',
                                        color: 'textPrimary',
                                        className: "section-discover__desc ".concat(classes.title),
                                        children: [
                                            ' ',
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                data: homePage === null || homePage === void 0 ? void 0 : (ref18 = homePage.data) === null || ref18 === void 0 ? void 0 : ref18.paragraph_universe1,
                                                asText: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (homePage === null || homePage === void 0 ? void 0 : (ref19 = homePage.data) === null || ref19 === void 0 ? void 0 : ref19.univers_layout) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)('fullwidth', classes.fullwidth),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: isArrows ? classes.swiperArrows : classes.swiperNoArrows,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            isArrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        className: classes.swiperArrow,
                                                        id: "swiper-taxon__prev",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        className: classes.swiperArrow,
                                                        id: "swiper-taxon__next",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                                                    })
                                                ]
                                            }),
                                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperTaxons, {
                                                params: swiperParamsTaxonsM
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperTaxons, {
                                                params: swiperParamsTaxonsD
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                container: true,
                                spacing: 3,
                                justify: 'center',
                                children: (taxons === null || taxons === void 0 ? void 0 : taxons.loading) !== true && (taxons === null || taxons === void 0 ? void 0 : taxons.items) && ((ref20 = taxons === null || taxons === void 0 ? void 0 : taxons.items[0]) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.children) === null || ref21 === void 0 ? void 0 : ref21.length) > 0 ? taxons.items[0].children.map(function(taxon, index) {
                                    if (index < (0,CMSText/* prismicText */.yz)(taxonLimit)) {
                                        var ref;
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            lg: isFiveColumns ? 2 : gridItemWidth,
                                            className: (0,clsx_m/* default */.Z)('section-discover__col', "section-discover__col--".concat(taxon.slug), isFiveColumns ? classes.md5 : classes.col, isMobileColumn && 'section-discover__col--mobile'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverCard, {
                                                    url: '/shop',
                                                    name: taxon.name,
                                                    taxonCat: taxon.slug,
                                                    img: (taxon === null || taxon === void 0 ? void 0 : taxon.images) && (taxon === null || taxon === void 0 ? void 0 : (ref = taxon.images) === null || ref === void 0 ? void 0 : ref.length) > 0 ? taxon === null || taxon === void 0 ? void 0 : taxon.images[0] : '',
                                                    ratio: aspectRatio,
                                                    thumbWidth: thumbWidth
                                                })
                                            })
                                        }, index));
                                    }
                                }) : [
                                    0,
                                    1,
                                    2
                                ].map(function(index) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 6,
                                        lg: isFiveColumns ? 2 : gridItemWidth,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'h3',
                                                    color: 'primary',
                                                    className: "discover__title ".concat(classes.taxonTitle),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        variant: 'text'
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    "data-ratio": aspectRatio,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        variant: "rect",
                                                        className: classes.skeletonImg
                                                    })
                                                })
                                            ]
                                        })
                                    }, index));
                                })
                            })
                        ]
                    }),
                    (homePage === null || homePage === void 0 ? void 0 : (ref22 = homePage.data) === null || ref22 === void 0 ? void 0 : ref22.enable_products_carousel) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            order: (homePage === null || homePage === void 0 ? void 0 : (ref23 = homePage.data) === null || ref23 === void 0 ? void 0 : ref23.position_product_carrousel) || 2
                        },
                        children: [
                            (homePage === null || homePage === void 0 ? void 0 : (ref24 = homePage.data) === null || ref24 === void 0 ? void 0 : ref24.subtitle_universe3.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "section-discover__subtext--products ".concat(classes.subtitle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h2',
                                        color: 'textPrimary',
                                        className: "section-discover__subtitle ".concat(classes.title),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            data: homePage === null || homePage === void 0 ? void 0 : (ref25 = homePage.data) === null || ref25 === void 0 ? void 0 : ref25.subtitle_universe3
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: 'body1',
                                        color: 'textPrimary',
                                        className: "section-discover__desc ".concat(classes.title),
                                        children: [
                                            ' ',
                                            (0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref26 = homePage.data) === null || ref26 === void 0 ? void 0 : ref26.paragraph_universe3)
                                        ]
                                    })
                                ]
                            }),
                            (homePage === null || homePage === void 0 ? void 0 : (ref27 = homePage.data) === null || ref27 === void 0 ? void 0 : ref27.univers_layout) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)('fullwidth', classes.fullwidth),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: isArrows ? classes.swiperArrows : classes.swiperNoArrows,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            isArrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        className: classes.swiperArrow,
                                                        id: "swiper-products__prev",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        className: classes.swiperArrow,
                                                        id: "swiper-products__next",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                                                    })
                                                ]
                                            }),
                                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperProducts, {
                                                params: swiperParamsProductsM
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperProducts, {
                                                params: swiperParamsProductsD
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                container: true,
                                spacing: 3,
                                justify: 'center',
                                children: homePage === null || homePage === void 0 ? void 0 : (ref28 = homePage.data) === null || ref28 === void 0 ? void 0 : ref28.carousel_products.map(function(carousel_product, index) {
                                    var ref, ref47;
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 6,
                                        lg: isFiveColumns ? 2 : gridItemWidth,
                                        className: (0,clsx_m/* default */.Z)(isFiveColumns ? classes.md5 : classes.col, 'section-discover__col'),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverCard, {
                                            name: (0,CMSText/* prismicText */.yz)(carousel_product === null || carousel_product === void 0 ? void 0 : carousel_product.title),
                                            productPrice: (0,CMSText/* prismicText */.yz)(carousel_product === null || carousel_product === void 0 ? void 0 : carousel_product.price),
                                            url: (carousel_product === null || carousel_product === void 0 ? void 0 : (ref = carousel_product.link) === null || ref === void 0 ? void 0 : ref.url) || '/',
                                            img: carousel_product === null || carousel_product === void 0 ? void 0 : (ref47 = carousel_product.image) === null || ref47 === void 0 ? void 0 : ref47.url,
                                            isProduct: true,
                                            ratio: aspectRatio
                                        })
                                    }, index));
                                })
                            })
                        ]
                    }),
                    isPack && (homePage === null || homePage === void 0 ? void 0 : (ref29 = homePage.data) === null || ref29 === void 0 ? void 0 : ref29.enable_taxon_pack) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            order: (homePage === null || homePage === void 0 ? void 0 : (ref30 = homePage.data) === null || ref30 === void 0 ? void 0 : ref30.position_pack_category) || 3
                        },
                        children: [
                            (homePage === null || homePage === void 0 ? void 0 : (ref31 = homePage.data) === null || ref31 === void 0 ? void 0 : ref31.subtitle_universe1.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (0,clsx_m/* default */.Z)('section-discover__subtext', 'section-discover__subtext--packs', classes.subtitle),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'h2',
                                        color: 'textPrimary',
                                        className: "section-discover__subtitle ".concat(classes.title),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            data: homePage.data.subtitle_universe2
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body1',
                                        color: 'textPrimary',
                                        className: "section-discover__desc ".concat(classes.title),
                                        children: (0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref32 = homePage.data) === null || ref32 === void 0 ? void 0 : ref32.paragraph_universe2)
                                    })
                                ]
                            }),
                            (homePage === null || homePage === void 0 ? void 0 : (ref33 = homePage.data) === null || ref33 === void 0 ? void 0 : ref33.univers_layout) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)('fullwidth', classes.fullwidth),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: isArrows ? classes.swiperArrows : classes.swiperNoArrows,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            isArrows && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        className: classes.swiperArrow,
                                                        id: "swiper-taxonPack__prev",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowLeft/* default */.Z, {})
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        className: classes.swiperArrow,
                                                        id: "swiper-taxonPack__next",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowRight/* default */.Z, {})
                                                    })
                                                ]
                                            }),
                                            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperTaxonPacks, {
                                                params: swiperParamsTaxonsPacksM
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperTaxonPacks, {
                                                params: swiperParamsTaxonsPacksD
                                            })
                                        ]
                                    })
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                container: true,
                                spacing: 3,
                                justify: 'center',
                                children: (taxonPack === null || taxonPack === void 0 ? void 0 : taxonPack.loading) !== true && (taxonPack === null || taxonPack === void 0 ? void 0 : taxonPack.items) && ((ref34 = taxonPack.items) === null || ref34 === void 0 ? void 0 : ref34.length) > 0 ? (ref35 = taxonPack.items) === null || ref35 === void 0 ? void 0 : ref35.map(function(taxon, index) {
                                    var ref;
                                    if (index < parseInt((0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref = homePage.data) === null || ref === void 0 ? void 0 : ref.pack_taxon_limit_number))) {
                                        var ref48;
                                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                            item: true,
                                            xs: 6,
                                            lg: isFiveColumns ? 2 : gridItemWidth,
                                            className: isFiveColumns ? classes.md5 : classes.col,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscoverCard, {
                                                url: '/packs',
                                                name: taxon.name,
                                                taxonCat: taxon.code,
                                                img: (taxon === null || taxon === void 0 ? void 0 : taxon.images) && (taxon === null || taxon === void 0 ? void 0 : (ref48 = taxon.images) === null || ref48 === void 0 ? void 0 : ref48.length) > 0 ? taxon === null || taxon === void 0 ? void 0 : taxon.images[0] : '',
                                                ratio: aspectRatio
                                            })
                                        }, taxon.code));
                                    }
                                }) : [
                                    0,
                                    1,
                                    2
                                ].map(function(index) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                        item: true,
                                        xs: 6,
                                        lg: isFiveColumns ? 2 : gridItemWidth,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'h3',
                                                    color: 'primary',
                                                    className: "discover__title ".concat(classes.taxonTitle),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        variant: 'text'
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    "data-ratio": aspectRatio,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                        variant: "rect",
                                                        className: classes.skeletonImg
                                                    })
                                                })
                                            ]
                                        })
                                    }, index));
                                })
                            })
                        ]
                    }),
                    (0,CMSText/* isPrismicText */.LT)(homePage === null || homePage === void 0 ? void 0 : (ref36 = homePage.data) === null || ref36 === void 0 ? void 0 : ref36.univers_cta_label) && (homePage === null || homePage === void 0 ? void 0 : (ref37 = homePage.data) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.univers_cta_link) === null || ref38 === void 0 ? void 0 : ref38.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)('section-discover__footer', classes.footer),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: homePage === null || homePage === void 0 ? void 0 : (ref39 = homePage.data) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.univers_cta_link) === null || ref40 === void 0 ? void 0 : ref40.url,
                            scroll: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: (0,clsx_m/* default */.Z)('discover__cta', classes.cardLink),
                                onClick: function() {
                                    var ref, ref49, ref50, ref51, ref52;
                                    return trackEvent({
                                        category: 'HomePage',
                                        href: "".concat(homePage === null || homePage === void 0 ? void 0 : (ref = homePage.data) === null || ref === void 0 ? void 0 : (ref49 = ref.univers_cta_link) === null || ref49 === void 0 ? void 0 : ref49.url),
                                        action: "Click on ".concat((0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref50 = homePage.data) === null || ref50 === void 0 ? void 0 : ref50.univers_cta_label)),
                                        name: "Universe Section to ".concat(homePage === null || homePage === void 0 ? void 0 : (ref51 = homePage.data) === null || ref51 === void 0 ? void 0 : (ref52 = ref51.univers_cta_link) === null || ref52 === void 0 ? void 0 : ref52.url)
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: 'primary',
                                    variant: 'contained',
                                    component: 'span',
                                    children: (0,CMSText/* prismicText */.yz)(homePage === null || homePage === void 0 ? void 0 : (ref41 = homePage.data) === null || ref41 === void 0 ? void 0 : ref41.univers_cta_label)
                                })
                            })
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var UniversSection = ((0,es/* connect */.$j)(UniversSection_mapStateToProps, UniversSection_mapDispatchToProps)(Discover));

// EXTERNAL MODULE: ./components/InstaWall/InstaWall.tsx
var InstaWall = __webpack_require__(52965);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/GridList/GridList.js
var GridList = __webpack_require__(87193);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/GridListTile/GridListTile.js
var GridListTile = __webpack_require__(45332);
;// CONCATENATED MODULE: ./components/HomePage/PartnersSection.tsx






function PartnersSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PartnersSection_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: PartnersSection_defineProperty({
            padding: theme.spacing(6, 0)
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(2, 0)
        }),
        content: {
            maxWidth: 900 + theme.spacing(6),
            '& .MuiGridListTile-root': {
                transition: theme.transitions.create('opacity'),
                willChange: 'opacity'
            }
        },
        contentSmall: {
            maxWidth: 600 + theme.spacing(6)
        },
        img: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        overlay: {
            position: 'absolute',
            zIndex: 1,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        active: {
            opacity: 1,
            '& .MuiGridListTile-root': {
                opacity: 0.75,
                '&:hover': {
                    opacity: 1
                }
            }
        },
        inactive: {
            opacity: 1
        }
    });
});
var PartnerText = function(props) {
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
        variant: 'srOnly',
        onClick: function() {
            return trackEvent({
                category: 'HomePage',
                href: props.link,
                action: "Link click ".concat(props.image.alt === null ? "".concat(props.text, " ").concat(props.index + 1) : props.image.alt),
                name: "from Partners section to ".concat(props.link)
            });
        },
        children: props.image.alt === null ? "".concat(props.text, " ").concat(props.index + 1) : props.image.alt
    }));
};
var PartnersSection = function(param) {
    var data = param.data;
    var classes = PartnersSection_useStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(false), active = ref[0], setActive = ref[1];
    var theme = (0,useTheme/* default */.Z)();
    var isTablet = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('md'));
    var partners = data.partners_list;
    var cols = partners.length <= 2 ? 2 : 3;
    var handleActiveTiles = function() {
        setActive(true);
    };
    var handleInActiveTiles = function() {
        setActive(false);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-partners section__spacer ".concat(classes.root),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            className: partners.length <= 2 ? "".concat(classes.content, " ").concat(classes.contentSmall) : classes.content,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridList/* default */.Z, {
                cellHeight: isTablet ? 'auto' : 300,
                cols: isTablet ? 2 : cols,
                spacing: 0,
                className: active ? classes.active : classes.inactive,
                onMouseOver: function() {
                    return handleActiveTiles();
                },
                onMouseOut: function() {
                    return handleInActiveTiles();
                },
                children: partners.map(function(partner, index) {
                    var link = partner.link, image = partner.image;
                    var linkType = link.link_type;
                    var linkTarget = link.target;
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(GridListTile/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: 'h2',
                                    children: linkType !== 'Any' ? linkType === 'Web' ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: link.url,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: classes.overlay,
                                            target: linkTarget !== '_blank' ? '_self' : '_blank',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerText, {
                                                image: image,
                                                text: t('texts:homepage:partner'),
                                                index: index,
                                                link: link.url
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "".concat(link.type, "/").concat(link.uid),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: classes.overlay,
                                            target: linkTarget !== '_blank' ? '_self' : '_blank',
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerText, {
                                                image: image,
                                                text: t('texts:homepage:partner'),
                                                index: index,
                                                link: "".concat(link.type, "/").concat(link.uid)
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PartnerText, {
                                        image: image,
                                        text: t('texts:homepage:partner'),
                                        index: index
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: classes.img,
                                    src: image.url,
                                    alt: ""
                                })
                            ]
                        })
                    }, index));
                })
            })
        })
    }));
};
/* harmony default export */ var HomePage_PartnersSection = (PartnersSection);

// EXTERNAL MODULE: ./components/Faq/FaqQuestion.tsx
var FaqQuestion = __webpack_require__(14582);
;// CONCATENATED MODULE: ./components/HomePage/FaqSection.tsx









function FaqSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var FaqSection_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: FaqSection_defineProperty({
            padding: theme.spacing(6, 0)
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(2, 0)
        }),
        align_center: {
            textAlign: 'center',
            margin: 'auto'
        },
        padding_top: {
            paddingTop: theme.spacing(3)
        },
        spacing: FaqSection_defineProperty({
            padding: theme.spacing(8)
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(0)
        }),
        faqItem: {
            marginBottom: theme.spacing(2)
        }
    });
});
var FaqSection = function(param) {
    var doc = param.doc, isTakeBack = param.isTakeBack, page = param.page;
    var ref8, ref1, ref2, ref3, ref4, ref5, ref6;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var classes = FaqSection_useStyles();
    var faqs = doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.q_a;
    var faqTitle = doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.faq_title;
    var faqDesc = doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.faq_description;
    var faqCTALink = doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.faq_cta;
    var faqCTALabel = doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.faq_cta_label;
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var ref7 = (0,react.useState)({
        cat: null,
        question: null
    }), isExpanded = ref7[0], setIsExpanded = ref7[1];
    var handleExpandClick = function(question, cat) {
        if (isExpanded.question === question) {
            setIsExpanded({
                cat: null,
                question: null
            });
        } else {
            setIsExpanded({
                cat: cat,
                question: question
            });
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "".concat(isTakeBack ? 'section-faq-tb' : 'section-faq', " section__spacer ").concat(classes.root),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat(classes.align_center),
                    children: [
                        (faqTitle === null || faqTitle === void 0 ? void 0 : faqTitle.length) > 0 && ((ref5 = faqTitle[0]) === null || ref5 === void 0 ? void 0 : ref5.text.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: 'primary',
                            variant: 'h2',
                            className: "section-faq__title ".concat(classes.padding_top),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                asText: true,
                                data: faqTitle,
                                defaultText: t('texts:general:FAQ')
                            })
                        }),
                        (faqDesc === null || faqDesc === void 0 ? void 0 : faqDesc.length) > 0 && ((ref6 = faqDesc[0]) === null || ref6 === void 0 ? void 0 : ref6.text.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body1',
                            className: "section-faq__subtitle ".concat(classes.padding_top),
                            component: 'div',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: faqDesc
                            })
                        }),
                        faqs && faqs.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classes.padding_top,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(faq, index) {
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                        className: "faq__item ".concat(classes.faqItem),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqQuestion/* default */.Z, {
                                            question: faq.question,
                                            questionId: index,
                                            isExpanded: isExpanded.question === index,
                                            handleExpandClick: handleExpandClick,
                                            close_others: doc === null || doc === void 0 ? void 0 : (ref = doc.data) === null || ref === void 0 ? void 0 : ref.close_others_on_click,
                                            answer: faq.answer
                                        })
                                    }, index);
                                })
                            })
                        }),
                        (0,CMSText/* isPrismicText */.LT)(faqCTALabel) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: (faqCTALink === null || faqCTALink === void 0 ? void 0 : faqCTALink.url) ? faqCTALink === null || faqCTALink === void 0 ? void 0 : faqCTALink.url : '',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                target: (faqCTALink === null || faqCTALink === void 0 ? void 0 : faqCTALink.target) === '_blank' ? '_blank' : '_self',
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: 'contained',
                                    color: 'primary',
                                    className: 'section-faq__cta',
                                    onClick: function() {
                                        return trackEvent({
                                            category: page,
                                            action: "click text",
                                            name: "".concat(faqCTALink === null || faqCTALink === void 0 ? void 0 : faqCTALink.url)
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: faqCTALabel
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        })
    }));
};
/* harmony default export */ var HomePage_FaqSection = (FaqSection);

;// CONCATENATED MODULE: ./components/HomePage/MenuSection.tsx






function MenuSection_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var MenuSection_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    var _obj;
    return (0,createStyles/* default */.Z)({
        root: MenuSection_defineProperty({
            padding: theme.spacing(6, 0)
        }, theme.breakpoints.down('sm'), {
            padding: theme.spacing(2, 0)
        }),
        loading: {
            pointerEvents: 'none',
            opacity: 0.5,
            userSelect: 'none'
        },
        list: {
            padding: theme.spacing(2, 0),
            margin: 0,
            whiteSpace: 'nowrap',
            listStyle: 'none',
            display: 'block',
            overflowX: 'auto',
            overflowY: 'hidden',
            WebkitOverflowScrolling: 'touch',
            '&> li': (_obj = {
                display: 'inline-block',
                marginRight: theme.spacing(1)
            }, MenuSection_defineProperty(_obj, theme.breakpoints.up('lg'), {
                marginRight: theme.spacing(3)
            }), MenuSection_defineProperty(_obj, '& a', {
                color: theme.palette.primary.main,
                '&:hover, &:focus': {
                    color: theme.palette.primary.dark
                }
            }), _obj)
        },
        cta: {
            color: theme.palette.common.black,
            '&:hover, &:focus': {
                color: theme.palette.secondary.main
            }
        }
    });
});
var MenuLink = function(props) {
    var ref6, ref1, ref2;
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: ((ref6 = props.link) === null || ref6 === void 0 ? void 0 : ref6.url) ? (ref1 = props.link) === null || ref1 === void 0 ? void 0 : ref1.url : '/',
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: 'section-menu__link',
            target: ((ref2 = props.link) === null || ref2 === void 0 ? void 0 : ref2.target) === '_blank' ? '_blank' : '_self',
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                component: 'span',
                onClick: function() {
                    var ref, ref3, ref4, ref5;
                    return trackEvent({
                        category: 'HomePage',
                        href: ((ref = props.link) === null || ref === void 0 ? void 0 : ref.url) ? (ref3 = props.link) === null || ref3 === void 0 ? void 0 : ref3.url : '/',
                        action: "CTA click ".concat(props.label),
                        name: "from Menu section to ".concat(((ref4 = props.link) === null || ref4 === void 0 ? void 0 : ref4.url) ? (ref5 = props.link) === null || ref5 === void 0 ? void 0 : ref5.url : '/')
                    });
                },
                children: props.label
            })
        })
    }));
};
var MenuSection = function(param) {
    var homePage = param.homePage;
    var classes = MenuSection_useStyles();
    var theme = (0,useTheme/* default */.Z)();
    var list = homePage === null || homePage === void 0 ? void 0 : homePage.menu_list;
    var menuCTALink = homePage === null || homePage === void 0 ? void 0 : homePage.menu_cta_link;
    var menuCTALabel = homePage === null || homePage === void 0 ? void 0 : homePage.menu_cta_label;
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down('sm'));
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: (0,clsx_m/* default */.Z)('section-menu', 'section__spacer', classes.root),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "xl",
                children: menuCTALink.url !== undefined ? isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: classes.list,
                    children: [
                        list.map(function(el, index) {
                            return el.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                    link: el.link,
                                    label: el.label
                                })
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: menuCTALink.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: (menuCTALink === null || menuCTALink === void 0 ? void 0 : menuCTALink.target) === '_blank' ? '_blank' : '_self',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: 'span',
                                        className: "section-menu__cta ".concat(classes.cta),
                                        onClick: function() {
                                            return trackEvent({
                                                category: 'HomePage',
                                                href: menuCTALink.url,
                                                action: "CTA click ".concat(menuCTALabel),
                                                name: "from Menu section to ".concat(menuCTALink.url)
                                            });
                                        },
                                        children: menuCTALabel
                                    })
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    spacing: 2,
                    justify: 'space-between',
                    alignItems: 'center',
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 9,
                            lg: 'auto',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: classes.list,
                                children: list.map(function(el, index) {
                                    return el.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                            link: el.link,
                                            label: el.label
                                        })
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 3,
                            lg: 'auto',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: menuCTALink.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    target: (menuCTALink === null || menuCTALink === void 0 ? void 0 : menuCTALink.target) === '_blank' ? '_blank' : '_self',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: 'span',
                                        className: "section-menu__cta ".concat(classes.cta),
                                        onClick: function() {
                                            return trackEvent({
                                                category: 'HomePage',
                                                href: menuCTALink.url,
                                                action: "CTA click ".concat(menuCTALabel),
                                                name: "from Menu section to ".concat(menuCTALink.url)
                                            });
                                        },
                                        children: menuCTALabel
                                    })
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (0,clsx_m/* default */.Z)(classes.list, 'section-list'),
                    children: list.map(function(el, index) {
                        return el.label && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuLink, {
                                link: el.link,
                                label: el.label
                            }, index)
                        }, index);
                    })
                })
            })
        })
    }));
};
/* harmony default export */ var HomePage_MenuSection = (MenuSection);

// EXTERNAL MODULE: ./utils/scrollState.tsx
var utils_scrollState = __webpack_require__(75216);
// EXTERNAL MODULE: ./components/HrefLangLinks.tsx
var HrefLangLinks = __webpack_require__(39998);
;// CONCATENATED MODULE: ./pages/index.tsx


















function pages_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function pages_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            pages_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var TestimonialSection = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 85974).then(__webpack_require__.bind(__webpack_require__, 85974));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85974)
            ];
        }
    }
});
var SharedHead = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 62788).then(__webpack_require__.bind(__webpack_require__, 62788));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62788)
            ];
        }
    }
});
var Footer = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 48884).then(__webpack_require__.bind(__webpack_require__, 53703));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53703)
            ];
        }
    }
});
var CommunitySection = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 83302).then(__webpack_require__.bind(__webpack_require__, 83302));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(83302)
            ];
        }
    }
});
var Banner = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 28565));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28565)
            ];
        }
    }
});
var SavingsSection = (0,dynamic["default"])(function() {
    return Promise.all(/* import() */[__webpack_require__.e(24951), __webpack_require__.e(21225)]).then(__webpack_require__.bind(__webpack_require__, 21225));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21225)
            ];
        }
    }
});
var InformationsSection = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 78979).then(__webpack_require__.bind(__webpack_require__, 78979));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78979)
            ];
        }
    }
});
var HowItWorksSection = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 6260).then(__webpack_require__.bind(__webpack_require__, 6260));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6260)
            ];
        }
    }
});
var HerosSection = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 25214).then(__webpack_require__.bind(__webpack_require__, 25214));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25214)
            ];
        }
    }
});
var pages_mapStateToProps = function(state) {
    return {
        parameters: state.parameters
    };
};
var Home = function(param1) {
    var homepageRes = param1.homepageRes, generalRes = param1.generalRes, statements = param1.statements, banner = param1.banner, instore = param1.instore, instagram = param1.instagram, basketRes = param1.basketRes, accountRes = param1.accountRes, faqRes = param1.faqRes, takeback = param1.takeback, parameters = param1.parameters;
    var ref52, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47;
    var inViewOpts = {
        threshold: 0.1,
        triggerOnce: true
    };
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var trackPageView = (0,useMatomo/* default */.Z)().trackPageView;
    var scrollState = (0,utils_scrollState/* useScrollState */.M)();
    var isBanner = (0,CMSText/* isPrismicText */.LT)(banner === null || banner === void 0 ? void 0 : (ref52 = banner.data) === null || ref52 === void 0 ? void 0 : ref52.text);
    var isEnableChooseStartingDate = parameters === null || parameters === void 0 ? void 0 : (ref1 = parameters.items) === null || ref1 === void 0 ? void 0 : ref1.enableChooseStartingDate;
    var ref48;
    var hrefLangs = (0,react.useMemo)(function() {
        var ref, ref49, ref50, ref51;
        return (ref48 = generalRes === null || generalRes === void 0 ? void 0 : (ref = generalRes.data) === null || ref === void 0 ? void 0 : (ref49 = ref.href_languages) === null || ref49 === void 0 ? void 0 : (ref50 = ref49[0]) === null || ref50 === void 0 ? void 0 : (ref51 = ref50.text) === null || ref51 === void 0 ? void 0 : ref51.split(',')) !== null && ref48 !== void 0 ? ref48 : [];
    }, [
        generalRes
    ]);
    // Track page view
    (0,react.useEffect)(function() {
        trackPageView({
            documentTitle: 'HomePage'
        });
    }, []);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page page--home",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SharedHead, {
                datas: generalRes
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: (0,CMSText/* prismicText */.yz)(homepageRes === null || homepageRes === void 0 ? void 0 : (ref2 = homepageRes.data) === null || ref2 === void 0 ? void 0 : ref2.meta_title_homepage, t('texts:general:baseline'))
                    }, "homePageTitle"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        property: "og:title",
                        content: (0,CMSText/* prismicText */.yz)(homepageRes === null || homepageRes === void 0 ? void 0 : (ref3 = homepageRes.data) === null || ref3 === void 0 ? void 0 : ref3.meta_title_homepage, t('texts:general:baseline'))
                    }),
                    (homepageRes === null || homepageRes === void 0 ? void 0 : (ref4 = homepageRes.data) === null || ref4 === void 0 ? void 0 : ref4.meta_description_homepage) && ((ref6 = homepageRes === null || homepageRes === void 0 ? void 0 : (ref5 = homepageRes.data) === null || ref5 === void 0 ? void 0 : ref5.meta_description_homepage[0]) === null || ref6 === void 0 ? void 0 : ref6.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: (0,CMSText/* prismicText */.yz)(homepageRes === null || homepageRes === void 0 ? void 0 : (ref7 = homepageRes.data) === null || ref7 === void 0 ? void 0 : ref7.meta_description_homepage)
                    }),
                    (homepageRes === null || homepageRes === void 0 ? void 0 : (ref8 = homepageRes.data) === null || ref8 === void 0 ? void 0 : ref8.meta_keywords_homepage) && ((ref10 = homepageRes === null || homepageRes === void 0 ? void 0 : (ref9 = homepageRes.data) === null || ref9 === void 0 ? void 0 : ref9.meta_keywords_homepage[0]) === null || ref10 === void 0 ? void 0 : ref10.text) && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: (0,CMSText/* prismicText */.yz)(homepageRes === null || homepageRes === void 0 ? void 0 : (ref11 = homepageRes.data) === null || ref11 === void 0 ? void 0 : ref11.meta_keywords_homepage)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HrefLangLinks/* default */.Z, {
                locales: hrefLangs
            }),
            isBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner, {
                banner: banner,
                t: t
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_HeroHome, {
                settings: homepageRes === null || homepageRes === void 0 ? void 0 : homepageRes.data,
                t: t,
                text: (generalRes === null || generalRes === void 0 ? void 0 : generalRes.data) && generalRes.data,
                isProduct: homepageRes === null || homepageRes === void 0 ? void 0 : (ref12 = homepageRes.data) === null || ref12 === void 0 ? void 0 : ref12.show_featured_products,
                statements: statements,
                isEnableChooseStartingDate: isEnableChooseStartingDate,
                children: !(generalRes === null || generalRes === void 0 ? void 0 : (ref13 = generalRes.data) === null || ref13 === void 0 ? void 0 : ref13.hide_header) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                    isHomePage: true,
                    doc: generalRes,
                    account: accountRes,
                    faq: faqRes,
                    t: t,
                    logo: generalRes === null || generalRes === void 0 ? void 0 : (ref14 = generalRes.data) === null || ref14 === void 0 ? void 0 : ref14.logo,
                    isTransparent: homepageRes === null || homepageRes === void 0 ? void 0 : (ref15 = homepageRes.data) === null || ref15 === void 0 ? void 0 : ref15.header_style,
                    logoTransparent: homepageRes === null || homepageRes === void 0 ? void 0 : (ref16 = homepageRes.data) === null || ref16 === void 0 ? void 0 : ref16.logo_transparent,
                    showOnScrollUp: scrollState.showOnScrollUp,
                    showOnTop: scrollState.showOnTop,
                    isBanner: isBanner,
                    inStoreText: instore,
                    textColor: generalRes === null || generalRes === void 0 ? void 0 : (ref17 = generalRes.data) === null || ref17 === void 0 ? void 0 : ref17.header_text_color,
                    background: generalRes === null || generalRes === void 0 ? void 0 : (ref18 = generalRes.data) === null || ref18 === void 0 ? void 0 : ref18.header_background,
                    hoverColor: generalRes === null || generalRes === void 0 ? void 0 : (ref19 = generalRes.data) === null || ref19 === void 0 ? void 0 : ref19.header_text_hover_color,
                    basket: basketRes,
                    takeback: takeback,
                    submenuBackgroundColor: generalRes === null || generalRes === void 0 ? void 0 : (ref20 = generalRes.data) === null || ref20 === void 0 ? void 0 : ref20.header_submenu_background_color,
                    submenuTextColor: generalRes === null || generalRes === void 0 ? void 0 : (ref21 = generalRes.data) === null || ref21 === void 0 ? void 0 : ref21.header_submenu_text_color
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                id: "more",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flexContent",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref22 = homepageRes.data) === null || ref22 === void 0 ? void 0 : ref22.position_how_it_works) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref23 = homepageRes.data) === null || ref23 === void 0 ? void 0 : ref23.is_howitworks_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksSection, {
                                                homePage: homepageRes,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref24 = homepageRes.data) === null || ref24 === void 0 ? void 0 : ref24.position_faq) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref25 = homepageRes.data) === null || ref25 === void 0 ? void 0 : ref25.is_faq_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_FaqSection, {
                                                doc: homepageRes,
                                                page: 'HomePage'
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref26 = homepageRes.data) === null || ref26 === void 0 ? void 0 : ref26.position_savings) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref27 = homepageRes.data) === null || ref27 === void 0 ? void 0 : ref27.is_savings_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SavingsSection, {
                                                homePage: homepageRes,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref28 = homepageRes.data) === null || ref28 === void 0 ? void 0 : ref28.position_heros) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref29 = homepageRes.data) === null || ref29 === void 0 ? void 0 : ref29.is_herosections_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HerosSection, {
                                                homePage: homepageRes,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref30 = homepageRes.data) === null || ref30 === void 0 ? void 0 : ref30.position_univers) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref31 = homepageRes.data) === null || ref31 === void 0 ? void 0 : ref31.is_universe_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        var ref53, ref54;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UniversSection, {
                                                homePage: homepageRes,
                                                taxonLimit: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref53 = homepageRes.data) === null || ref53 === void 0 ? void 0 : ref53.taxon_number_limit) || 6,
                                                isPack: (generalRes === null || generalRes === void 0 ? void 0 : (ref54 = generalRes.data) === null || ref54 === void 0 ? void 0 : ref54.pack_page) || false,
                                                settings: generalRes === null || generalRes === void 0 ? void 0 : generalRes.data,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref32 = homepageRes.data) === null || ref32 === void 0 ? void 0 : ref32.position_information) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref33 = homepageRes.data) === null || ref33 === void 0 ? void 0 : ref33.is_information_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationsSection, {
                                                homePage: homepageRes,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref34 = homepageRes.data) === null || ref34 === void 0 ? void 0 : ref34.position_more_information) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref35 = homepageRes.data) === null || ref35 === void 0 ? void 0 : ref35.is_more_information_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationsSection, {
                                                isMoreInfo: true,
                                                homePage: homepageRes,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref36 = homepageRes.data) === null || ref36 === void 0 ? void 0 : ref36.position_testimonials) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref37 = homepageRes.data) === null || ref37 === void 0 ? void 0 : ref37.is_testimonials_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialSection, {
                                                homePage: homepageRes,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref38 = homepageRes.data) === null || ref38 === void 0 ? void 0 : ref38.position_community) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref39 = homepageRes.data) === null || ref39 === void 0 ? void 0 : ref39.is_community_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CommunitySection, {
                                                homePage: homepageRes,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref40 = homepageRes.data) === null || ref40 === void 0 ? void 0 : ref40.position_instawall) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref41 = homepageRes.data) === null || ref41 === void 0 ? void 0 : ref41.is_instagram_active) && instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InstaWall/* default */.Z, {
                                                data: instagram.data,
                                                t: t
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref42 = homepageRes.data) === null || ref42 === void 0 ? void 0 : ref42.position_partners) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref43 = homepageRes.data) === null || ref43 === void 0 ? void 0 : ref43.is_partners_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_PartnersSection, {
                                                data: homepageRes === null || homepageRes === void 0 ? void 0 : homepageRes.data
                                            })
                                        });
                                    }
                                }))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    order: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref44 = homepageRes.data) === null || ref44 === void 0 ? void 0 : ref44.position_menu) || 1
                                },
                                children: (homepageRes === null || homepageRes === void 0 ? void 0 : (ref45 = homepageRes.data) === null || ref45 === void 0 ? void 0 : ref45.is_menu_active) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                                    children: function(param) {
                                        var ref = param.ref, inView = param.inView;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                            className: "fade",
                                            ref: ref,
                                            style: {
                                                opacity: inView ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_MenuSection, {
                                                homePage: homepageRes === null || homepageRes === void 0 ? void 0 : homepageRes.data
                                            })
                                        });
                                    }
                                }))
                            })
                        ]
                    }),
                    (homepageRes === null || homepageRes === void 0 ? void 0 : (ref46 = homepageRes.data) === null || ref46 === void 0 ? void 0 : ref46.display_take_back_faq) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_intersection_observer_modern/* InView */.df, pages_objectSpread({}, inViewOpts, {
                        children: function(param) {
                            var ref = param.ref, inView = param.inView;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("div", {
                                className: "fade",
                                ref: ref,
                                style: {
                                    opacity: inView ? 1 : 0
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_FaqSection, {
                                    doc: homepageRes,
                                    isTakeBack: true,
                                    page: 'HomePage'
                                })
                            });
                        }
                    }))
                ]
            }),
            !(generalRes === null || generalRes === void 0 ? void 0 : (ref47 = generalRes.data) === null || ref47 === void 0 ? void 0 : ref47.hide_footer) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                    doc: generalRes,
                    t: t
                })
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ var pages = ((0,es/* connect */.$j)(pages_mapStateToProps)(Home));


/***/ }),

/***/ 37876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "NX": function() { return /* binding */ deletePackOrigin; },
  "Ht": function() { return /* binding */ getPackTaxons; },
  "M9": function() { return /* binding */ packs_getPacksByPackTaxonId; },
  "VH": function() { return /* binding */ saveCurrentPack; },
  "Dq": function() { return /* binding */ savePackOrigin; }
});

// UNUSED EXPORTS: ACTIONS, DELETE_PACK_ORIGIN, GET_PACKS_BY_PACK_TAXON_ID_FAILURE, GET_PACKS_BY_PACK_TAXON_ID_REQUEST, GET_PACKS_BY_PACK_TAXON_ID_SUCCESS, GET_PACKS_TAXONS_FAILURE, GET_PACKS_TAXONS_REQUEST, GET_PACKS_TAXONS_SUCCESS, SAVE_CURRENT_PACK, SAVE_PACK_ORIGIN

// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/packs.ts


var getPacksTaxons = function() {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.taxonPack */.KU.taxonPack
    });
};
var getPacksByPackTaxonId = function(id) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.get */.YZ.get,
        url: requests/* ERequestUrl.packs */.KU.packs,
        uid: "".concat(id)
    });
};

;// CONCATENATED MODULE: ./redux/actions/packs.ts

var ACTIONS = {
    GET_PACKS_TAXONS_REQUEST: 'GET_PACKS_TAXONS_REQUEST',
    GET_PACKS_TAXONS_SUCCESS: 'GET_PACKS_TAXONS_SUCCESS',
    GET_PACKS_TAXONS_FAILURE: 'GET_PACKS_TAXONS_FAILURE',
    GET_PACKS_BY_PACK_TAXON_ID_REQUEST: 'GET_PACKS_BY_PACK_TAXON_ID_REQUEST',
    GET_PACKS_BY_PACK_TAXON_ID_SUCCESS: 'GET_PACKS_BY_PACK_TAXON_ID_SUCCESS',
    GET_PACKS_BY_PACK_TAXON_ID_FAILURE: 'GET_PACKS_BY_PACK_TAXON_ID_FAILURE',
    SAVE_CURRENT_PACK: 'SAVE_CURRENT_PACK',
    SAVE_PACK_ORIGIN: 'SAVE_PACK_ORIGIN',
    DELETE_PACK_ORIGIN: 'DELETE_PACK_ORIGIN'
};
var GET_PACKS_TAXONS_REQUEST = function() {
    return {
        type: ACTIONS.GET_PACKS_TAXONS_REQUEST
    };
};
var GET_PACKS_TAXONS_SUCCESS = function(taxonPack) {
    return {
        type: ACTIONS.GET_PACKS_TAXONS_SUCCESS,
        taxonPack: taxonPack
    };
};
var GET_PACKS_TAXONS_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PACKS_TAXONS_FAILURE,
        err: err
    };
};
function getPackTaxons() {
    return function(dispatch) {
        dispatch(GET_PACKS_TAXONS_REQUEST());
        return getPacksTaxons().then(function(response) {
            return dispatch(GET_PACKS_TAXONS_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PACKS_TAXONS_FAILURE(err));
        });
    };
}
var GET_PACKS_BY_PACK_TAXON_ID_REQUEST = function() {
    return {
        type: ACTIONS.GET_PACKS_BY_PACK_TAXON_ID_REQUEST
    };
};
var GET_PACKS_BY_PACK_TAXON_ID_SUCCESS = function(packs) {
    return {
        type: ACTIONS.GET_PACKS_BY_PACK_TAXON_ID_SUCCESS,
        packs: packs
    };
};
var GET_PACKS_BY_PACK_TAXON_ID_FAILURE = function(err) {
    return {
        type: ACTIONS.GET_PACKS_BY_PACK_TAXON_ID_FAILURE,
        err: err
    };
};
function packs_getPacksByPackTaxonId(id) {
    return function(dispatch) {
        dispatch(GET_PACKS_BY_PACK_TAXON_ID_REQUEST());
        return getPacksByPackTaxonId(id).then(function(response) {
            return dispatch(GET_PACKS_BY_PACK_TAXON_ID_SUCCESS(response));
        }, function(err) {
            return dispatch(GET_PACKS_BY_PACK_TAXON_ID_FAILURE(err));
        });
    };
}
var SAVE_CURRENT_PACK = function(currentPack) {
    return {
        type: ACTIONS.SAVE_CURRENT_PACK,
        currentPack: currentPack
    };
};
function saveCurrentPack(currentPack) {
    return function(dispatch) {
        dispatch(SAVE_CURRENT_PACK(currentPack));
    };
}
var SAVE_PACK_ORIGIN = function(origin) {
    return {
        type: ACTIONS.SAVE_PACK_ORIGIN,
        origin: origin
    };
};
function savePackOrigin(origin) {
    return function(dispatch) {
        dispatch(SAVE_PACK_ORIGIN(origin));
    };
}
var DELETE_PACK_ORIGIN = function() {
    return {
        type: ACTIONS.DELETE_PACK_ORIGIN
    };
};
function deletePackOrigin() {
    return function(dispatch) {
        dispatch(DELETE_PACK_ORIGIN());
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [282,2215,15350,79593,366,57443,94108,60533,76142,84997,12979,93723,19789,95188,4998,49774,92888,40179], function() { return __webpack_exec__(45301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);